[
  {
    "key": "Excel:Validation:JoinerIdMissing",
    "text": "Joiner Id is missing",
    "translations": [
      {
        "language": "AR",
        "text": "هوية الموظف مطلوبة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:EmployeeIdMissing",
    "text": "Employee Id is missing",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة رقم هوية الموظف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:DuplicateEmployeeId",
    "text": "Duplicate Employee Id",
    "translations": [
      {
        "language": "AR",
        "text": "رقم هوية الموظف مكررة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:ValueNotFound",
    "text": "Option Not Found",
    "translations": [
      {
        "language": "AR",
        "text": "الخيار غير موجود"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "Excel:Validation:Failed",
    "text": "Excel Validation Failed",
    "translations": [
      {
        "language": "AR",
        "text": "فشل التحقق من بيانات الملف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Row",
    "text": "Row",
    "translations": [
      {
        "language": "AR",
        "text": "صف"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "btn_Finish",
    "text": "Finish",
    "translations": [
      {
        "language": "AR",
        "text": "تم"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ErrorsEncountered",
    "text": "Errors Found",
    "translations": [
      {
        "language": "AR",
        "text": "تم العثور على أخطاء"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TotalUpdated",
    "text": "Total Updated",
    "translations": [
      {
        "language": "AR",
        "text": "إجمالي السجلات التي تم تحديثها"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_TotalProcessed",
    "text": "Total Processed",
    "translations": [
      {
        "language": "AR",
        "text": "جمالي السجلات المعالَجة"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_RecordsIdentified",
    "text": "Joiners Identified",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفون الجدد المحددون"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ValidationSuccessful",
    "text": "Joiners have been updated",
    "translations": [
      {
        "language": "AR",
        "text": "تم تعديل الموظفين الجدد"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtCriteriaForExistingLeavers",
    "text": "existing joiners criteria by linking it to their unique IDs",
    "translations": [
      {
        "language": "AR",
        "text": "معايير الموظفين المغادرين الموجودين بالفعل من خلال ربطها برقم الهوية الخاص بهم."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txtUpdate",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_ResultSummary",
    "text": "Update Summary",
    "translations": [
      {
        "language": "AR",
        "text": "مُلخص التعديلات"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdateSuccess",
    "text": "Update Success",
    "translations": [
      {
        "language": "AR",
        "text": "تم التعديل بنجاح"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdateDescriptionShort",
    "text": "Use a spreadsheet",
    "translations": [
      {
        "language": "AR",
        "text": "استعمل جدول"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdateDescription",
    "text": "You can update any leaver's information using their unique ID.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث معلومات أي موظف مغادر باستخدام رقم الهوية الفريد الخاص به."
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_BulkUpdate",
    "text": "Bulk Update",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل جماعي"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_Filters_429",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      },
      {
        "language": "FR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_DRIVER_MOD_SCORE",
    "text": "Factor Onboarding Score",
    "translations": [
      {
        "language": "AR",
        "text": ""
      }
    ]
  },
  {
    "key": "txt_joiners_list",
    "text": "Joiners List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين الجدد"
      }
    ]
  },
  {
    "key": "txt_DRIVER/IM_469",
    "text": "Impact / Factor",
    "translations": [
      {
        "language": "AR",
        "text": "التأثير / العامل"
      },
      {
        "language": "EN",
        "text": "Impact / Factor"
      }
    ]
  },
  {
    "key": "ap_module_score",
    "text": "Onboarding Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة الإعداد والتهيئة"
      }
    ]
  },
  {
    "key": "ap_for_survey",
    "text": "For Onboarding Survey:",
    "translations": [
      {
        "language": "AR",
        "text": "لـ استبيان إعداد وتهيئة:"
      }
    ]
  },
  {
    "key": "ap_by_driver",
    "text": "By Factor",
    "translations": [
      {
        "language": "AR",
        "text": "حسب العامل"
      }
    ]
  },
  {
    "key": "ap_section",
    "text": "Factor",
    "translations": [
      {
        "language": "AR",
        "text": "عامل"
      }
    ]
  },
  {
    "key": "txt_drivers",
    "text": "Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txt_ActionPla_663",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "txt_Youmaysel_822",
    "text": "You may select a maximum of 8 factors.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكن اختيار 8 عوامل كحد أقصى."
      }
    ]
  },
  {
    "key": "rawComments",
    "text": "Normal View",
    "translations": [
      {
        "language": "AR",
        "text": "العرض العادي"
      }
    ]
  },
  {
    "key": "txt_send",
    "text": "Send",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال"
      }
    ]
  },
  {
    "key": "txt_bulk_reminders",
    "text": "Are you sure you wish to send reminders to all pending joiners?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد من أنك ترغب في إرسال تذكيرات للموظفين الجدد الذين لم يستكملوا الاستبيان؟"
      }
    ]
  },
  {
    "key": "txtfrom",
    "text": "from",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      }
    ]
  },
  {
    "key": "btnExport_tour",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      }
    ]
  },
  {
    "key": "txt_view_answers",
    "text": "View Answers",
    "translations": [
      {
        "language": "AR",
        "text": "عرض الأجوبة"
      }
    ]
  },
  {
    "key": "txt_ShowComme_978",
    "text": "Show Comments ",
    "translations": [
      {
        "language": "AR",
        "text": "عرض التعليقات "
      }
    ]
  },
  {
    "key": "txt_Clickhere_266",
    "text": "Click here to show the comments (if any). ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التعليقات (إن وجدت). "
      }
    ]
  },
  {
    "key": "txt_extraFactor",
    "text": "Extra Factor ",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل إضافية "
      }
    ]
  },
  {
    "key": "txt_Clickhere_159",
    "text": "Click here to download all comments.</br>Note: Available in Excel format ",
    "translations": [
      {
        "language": "AR",
        "text": "انقرهنا لتحميل جميع التعليقات. </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txtComments_desc",
    "text": "Unlock the magic of AI with sentiment analysis in <b>“Comments”</b> – witness the power of your respondents’ feedback! ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف سحر الذكاء الصناعي من خلال تحليل المشاعر والآراء في <b>\"التعليقات\"</b> - شاهد قوة تعليقات المستجيبين!"
      }
    ]
  },
  {
    "key": "txt_Expandthe_711",
    "text": "Expand the factor to view each statement score and the distribution of joiners’ answers. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على العامل لعرض متوسط كل عبارة وتوزيع إجابات الموظفين الجدد. "
      }
    ]
  },
  {
    "key": "txtQuestions_desc",
    "text": "In \"Statements\", each factor’s score with its corresponding statement is shown. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"العبارات\"</b>، يتم عرض متوسط كل عامل مع العبارات الخاصة به."
      }
    ]
  },
  {
    "key": "txtStatements",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txt_Statement_817",
    "text": "Statements Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة العبارات "
      }
    ]
  },
  {
    "key": "txtJoinerAnalysis_desc",
    "text": "In <b>“Joiner’s Analysis”</b>, the charts shown depend on the analytical criteria filled in while adding a joiner. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"تحليلات الموظفين الجدد\"</b> تعتمد الرسوم البيانية المعروضة على المعايير التحليلية المُعبئة خلال إضافة الموظف الجديد. "
      }
    ]
  },
  {
    "key": "txt_Joiners’A_917",
    "text": "Joiners’ Analysis ",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات الموظفين الجدد "
      }
    ]
  },
  {
    "key": "txt_Changethe_415",
    "text": "Change the type of the chart by clicking here.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتغيير نوع الرسم البياني بالنقر هنا."
      }
    ]
  },
  {
    "key": "txt_ChartType_839",
    "text": "Chart Type ",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الرسم البياني "
      }
    ]
  },
  {
    "key": "txt_Unlockthe_410",
    "text": "Unlock the power of your preferences! Revisit the criteria you chose when you added the joiners and experience an analysis tailored to your specifications! </br>Hint: The system is interactive. Click on the chart legend to turn on/off options and have a clearer view of the results. ",
    "translations": [
      {
        "language": "AR",
        "text": "اكتشف قوة تحليلات زينيثرمع اختياراتك في إعدادات إضافة الموظفين الجدد! استمتع بتجربة مصممة ومفصّلة وفق مواصفاتك!</br> تلميح: النظام تفاعلي. انقر على مفتاح الرسم البياني لتفعيل/إيقاف الخيارات والحصول على رؤية أوضح للنتائج. "
      }
    ]
  },
  {
    "key": "txt_Workplace_118",
    "text": "Workplace Onboarding Experience ",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة الإعداد في مكان العمل "
      }
    ]
  },
  {
    "key": "txt_Didyouadd_483",
    "text": "Did you add any custom factors to your survey? Click here and start viewing the results! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل أضفت أي عوامل مخصصة إلى الاستبيان؟ انقر هنا وابدأ في عرض النتائج! "
      }
    ]
  },
  {
    "key": "txt_Areyouloo_654",
    "text": "Are you looking for a specific timeframe for your analysis? Set the start and end date and uncover the insights you need! ",
    "translations": [
      {
        "language": "AR",
        "text": "هل تبحث عن مدة زمنية محددة لعرض التحليلات؟ قم بتعيين تاريخ البدء والانتهاء واكتشف التحليلات التي تحتاجها! "
      }
    ]
  },
  {
    "key": "txt_FilterbyT_741",
    "text": "Filter by Timeframe ",
    "translations": [
      {
        "language": "AR",
        "text": "تصفية حسب المدة الزمنية "
      }
    ]
  },
  {
    "key": "txt_Clickhere_702",
    "text": "Click here to download the report and turn on the sections you want to include. </br>Hint: Easily access detailed entity reports by choosing your preferred entity type in the 'View by' menu and start downloading now!  - Available in PDF. ",
    "translations": [
      {
        "language": "AR",
        "text": " انقر هنا لتحميل التقرير واختر الأقسام التي ترغب في تضمينها في التقرير. </br>تلميح: قم بالوصول بسهولة إلى تقارير الوحدات التنظيمية المفصلة عن طريق اختيار نوع الوحدة التنظيمية في قائمة <b>\"تصفح عن طريق\"</b> وابدأ بالتحميل الآن! - متوفر في صيغة PDF."
      }
    ]
  },
  {
    "key": "txt_Clickhere_435",
    "text": "Click here to filter the analysis by choosing the entity. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض التحليلات عن طريق اختيار الوحدة التنظيمية. "
      }
    ]
  },
  {
    "key": "txtOverview_desc",
    "text": "The <b>“Overview”</b> page shows the joiners’ overall scores, factors scores, and other valuable insights.  ",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة <b>\"نظرة عامة\"</b> تعرض معدل تجربة الموظفين الجدد ومتوسط عوامل إعداد وتهيئة الموظفين والعديد من التحليلات الأخرى"
      }
    ]
  },
  {
    "key": "txt_Analysis_888",
    "text": "Analysis ",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات "
      }
    ]
  },
  {
    "key": "txtAnalytics_onBoarding",
    "text": "On the <b>“Analysis”</b> page, you uncover the overall results for joiners who completed the survey! ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"التحليلات\"</b> تكشف الدرجات الكلية لجميع الموظفين الجدد الذين استكملوا الاستبيان! "
      }
    ]
  },
  {
    "key": "txt_MoreActio_120",
    "text": "More Actions",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية"
      }
    ]
  },
  {
    "key": "txt_Clickhere_217",
    "text": "Click here and select <b>“Export Template”</b> to view your Survey's selected factors and statements! </br>You can also select <b>“Edit Template”</b> to rename your template or <b>“Delete Template”</b> to delete your template.</br>Note: Export is Available in PDF format. Careful! Only inactive templates can be edited or deleted. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"تحميل النموذج\"</b> لعرض العوامل والعبارات المختارة في الاستبيان الخاص بك!</br> يمكنك أيضاً تعديل او حذف النموذج بالنقر على <b>\"تعديل النموذج\"</b> أو<b> \"حذف النموذج\"</b>.</br> ملحوظة: تحميل النموذج متوفر في صيغة PDF. انتبه! لا يمكن تعديل أو حذف النماذج المستخدمة. "
      }
    ]
  },
  {
    "key": "txt_Useouradv_513",
    "text": "Use our advanced AI tool to generate statements tailored to your need! ",
    "translations": [
      {
        "language": "AR",
        "text": "استخدم أداة الذكاء الاصطناعي المتطورة لإنشاء عبارات مصممة خصيصًا لاحتياجاتك! "
      }
    ]
  },
  {
    "key": "txt_GenerateS_831",
    "text": "Generate Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات "
      }
    ]
  },
  {
    "key": "txt_GenerateS_331",
    "text": "Generate Statement ",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء عبارات "
      }
    ]
  },
  {
    "key": "btn_add_question",
    "text": "Add Statement",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة عبارة"
      }
    ]
  },
  {
    "key": "txt_Clickonb_566",
    "text": "Click on <b>“New Statement”</b> to add a new custom statement using the agreement scale question type.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على <b>\"عبارة جديدة\"</b> لإضافة عبارة مخصصة جديدة باستخدام نوع السؤال لمقياس الاتفاق."
      }
    ]
  },
  {
    "key": "txt_Editordel_384",
    "text": "Edit or delete the new custom Factor. ",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف العامل المخصص الجديد. "
      }
    ]
  },
  {
    "key": "txt_EditCusto_550",
    "text": "Edit Custom Factor",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل العامل المخصص "
      }
    ]
  },
  {
    "key": "txt_Ifyouwant_782",
    "text": "If you want to add more factors, click <b>“New Factor”</b>.</br> Note: Total factors covering the <b>BRACE</b> and Custom Factors shall not exceed 8 Factors. ",
    "translations": [
      {
        "language": "AR",
        "text": "إذا كنت ترغب في إضافة المزيد من العوامل، انقر على <b>\"عامل مخصص جديد\"</b>. </br>ملحوظة: يجب ألا يتجاوز إجمالي عوامل <b>BRACE</b> والمخصصة عن 8 عوامل. "
      }
    ]
  },
  {
    "key": "txt_CustomFac_521",
    "text": "Custom Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل مخصصة "
      }
    ]
  },
  {
    "key": "txt_Maximizey_766",
    "text": "Maximize your experience with the full <b>BRACE</b> predefined factors, or tailor it to your needs by selecting a minimum of 3 factors for the single-phased template. </br>Note: All <b>BRACE</b> factors are selected by default in the Two-Phased survey template. ",
    "translations": [
      {
        "language": "AR",
        "text": "حقق أقصى استفادة مع عوامل <b>BRACE</b> المُعرفة مسبقاً، أو قم بتخصيصها لتناسب احتياجاتك عن طريق اختيار 3 عوامل كحد أدنى لنموذج استبيان على مرحلة واحدة.</br> ملحوظة: يتم تحديد كافة عوامل <b>BRACE</b> في نموذج استبيان على مرحلتين.    "
      }
    ]
  },
  {
    "key": "txt_BRACEFact_965",
    "text": "BRACE Factors ",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل BRACE "
      }
    ]
  },
  {
    "key": "txt_Doyouhave_377",
    "text": "Do you have other statements you'd like to include in your survey? Look no further! Click here to start designing an employee onboarding survey tailored to your needs. </br>Hint: You can choose the format of your choice, single-phased (one survey) or two-phased (two surveys). ",
    "translations": [
      {
        "language": "AR",
        "text": "هل لديك عبارات أخرى ترغب في تضمينها في الاستبيان؟ لا داعي للبحث أكثر! انقر هنا لبدء تصميم استبيان إعداد وتهيئة الموظفين المصمم خصيصاً لتلبية احتياجاتك.</br> تلميحة: يمكنك اختيار التنسيق الذي يناسب احتياجك، استبيان على مرحلة واحدة أو استبيان على مرحلتين. "
      }
    ]
  },
  {
    "key": "txt_Manageria_395",
    "text": "Managerial Question ",
    "translations": [
      {
        "language": "AR",
        "text": "سؤال إداري "
      }
    ]
  },
  {
    "key": "txt_Thisicon_603",
    "text": "This icon “👤” distinguishes the managerial-level questions from the professional-level questions. ",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الرمز “👤” يميز أسئلة المستوى الإداري عن أسئلة المستوى المهني. "
      }
    ]
  },
  {
    "key": "txt_Clickhere_911",
    "text": "Click here to preview the general questions of the survey! ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض الأسئلة العامة للاستبيان! "
      }
    ]
  },
  {
    "key": "txt_GeneralQu_556",
    "text": "General Questions ",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة عامة "
      }
    ]
  },
  {
    "key": "txt_Clickhere_479",
    "text": "Click here to preview the employee onboarding factors and their statements! ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض عوامل وعبارات استبيان إعداد وتهيئة الموظفين! "
      }
    ]
  },
  {
    "key": "txt_Clickhere_488",
    "text": "Click here to preview the questions for the employee onboarding predefined templates!</br> Note: You cannot make any edits on predefined templates. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لعرض أسئلة نموذج استبيان إعداد وتهيئة الموظفين المُعرف مسبقاً! </br>ملحوظة: لا يمكنك إجراء أي تعديلات على النماذج المُعرفة مسبقاً. "
      }
    ]
  },
  {
    "key": "txt_Predefine_161",
    "text": "Predefined Templates ",
    "translations": [
      {
        "language": "AR",
        "text": "النماذج المُعرفة مسبقاً "
      }
    ]
  },
  {
    "key": "txtTemplate_onBoarding",
    "text": "In the <b>“Survey Templates”</b> page, you preview the predefined template questions and create new templates tailored to your needs! ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\"نماذج الاستبيان\"</b> يمكنك عرض أسئلة النماذج المُعرفة مسبقاُ وإنشاء نماذج جديدة مصممة خصيصاً لتلبية احتياجاتك! "
      }
    ]
  },
  {
    "key": "txt_Pointthem_258",
    "text": "Point the mouse over the joiners who completed the survey to view their answers. </br>Note: If the anonymity option was deactivated while adding joiners, you can view their answers. - Available in PDF format ",
    "translations": [
      {
        "language": "AR",
        "text": "ضع مؤشر الماوس فوق الموظف الجديد الذي استكمل الاستبيان لعرض الأجوبة. </br>ملحوظة: يمكنك عرض إجابة الموظفين الجدد في حال تم تعطيل خيار السرية أثناء إضافة الموظفين الجدد - متوفر في صيغة PDF. "
      }
    ]
  },
  {
    "key": "txt_MoreActio_676",
    "text": "More Actions ",
    "translations": [
      {
        "language": "AR",
        "text": "إجراءات إضافية  "
      }
    ]
  },
  {
    "key": "txt_Clickhere_336",
    "text": "Click here to send manual reminders and edit or delete the joiner. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لإرسال تذكيرات يدوية وتعديل أو حذف الموظف الجديد. "
      }
    ]
  },
  {
    "key": "txt_Clickhere_760",
    "text": "Click here to customize the list of joiners to your preference! ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتعديل قائمة الموظفين الجدد حسب تفضيلاتك! "
      }
    ]
  },
  {
    "key": "txt_Youcandow_317",
    "text": "You can download the list of joiners with their survey status! </br>Note: Available in Excel format. ",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحميل قائمة الموظفين الجدد مع حالة الاستبيان الخاص بهم! </br> ملحوظة: متوفر في صيغة Excel. "
      }
    ]
  },
  {
    "key": "txt_ExportJoi_373",
    "text": "Export Joiners ",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل الموظفين الجدد "
      }
    ]
  },
  {
    "key": "txt_Clickhere_771",
    "text": "Click here to filter the joiners’ list by survey status. ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لتصفية قائمة الموظفين الجدد حسب حالة الاستبيان. "
      }
    ]
  },
  {
    "key": "txt_Tostartad_523",
    "text": "To start adding joiners, click on <b>“New Joiner”</b>.  </br>You have the option to add joiners manually or by using Excel!  </br>Hint: We recommend adding by using Excel to save time and simplify your experience! ",
    "translations": [
      {
        "language": "AR",
        "text": "للبدء في إضافة الموظفين الجدد، انقر على <b>\"إضافة موظف جديد\"</b>.</br>   لديك الخيار لإضافة الموظفين الجدد يدوياً أو عبر ملف Excel!  </br>تلميح: نوصي باستخدام ملف Excel لتوفير الوقت وتسهيل تجربتك! "
      }
    ]
  },
  {
    "key": "txt_AddJoiner_945",
    "text": "Add Joiner",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة موظف جديد "
      }
    ]
  },
  {
    "key": "txt_SelectTem_448",
    "text": "Select Template ",
    "translations": [
      {
        "language": "AR",
        "text": "اختر النموذج "
      }
    ]
  },
  {
    "key": "txt_Clickhere_130",
    "text": "Click here to select the employee onboarding template you want to view (if any). ",
    "translations": [
      {
        "language": "AR",
        "text": "انقر هنا لاختيار وعرض النموذج لاستبيان إعداد وتهيئة الموظفين (إن وجد). "
      }
    ]
  },
  {
    "key": "txt_Onboarding_desc",
    "text": "On the <b>“Joiners List”</b> page, you add the new joiners, track their survey status, send reminders, and view each joiner’s answer individually. ",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة <b>\" قائمة الموظفين الجدد \"</b> تقوم بإضافة الموظفين الجدد وتتبع حالة الاستبيان وإرسال تذكيرات وعرض أجوبة كل موظف جديد على حدة. "
      }
    ]
  },
  {
    "key": "txtPreparingHeatmap",
    "text": "Preparing Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "جارِ تحضير المخطط"
      }
    ]
  },
  {
    "key": "txtDownloadHeatmap",
    "text": "Download Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل المخطط"
      }
    ]
  },
  {
    "key": "txtMaximum",
    "text": "High",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر"
      }
    ]
  },
  {
    "key": "txtMinimum",
    "text": "Low",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل"
      }
    ]
  },
  {
    "key": "txtMedian",
    "text": "Median",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtBreakout",
    "text": "Breakout:",
    "translations": [
      {
        "language": "AR",
        "text": "تفصيل حسب:"
      }
    ]
  },
  {
    "key": "txtComparisonOverall",
    "text": "Comparison: Overall",
    "translations": [
      {
        "language": "AR",
        "text": "مقارنة بالنسبة إلى: الكل"
      }
    ]
  },
  {
    "key": "txtheatmaptooltip",
    "text": "The value displayed in the cell is delta, which represents a difference in the overall value.",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم المكتوب داخل المربع يمثل الفرق بين النتيجة والمعدل الكلي."
      }
    ]
  },
  {
    "key": "txtHeatmap",
    "text": "Heatmap",
    "translations": [
      {
        "language": "AR",
        "text": "مخطط تمثيل البيانات بالألوان"
      }
    ]
  },
  {
    "key": "txt_download_comments",
    "text": "Download Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التعليقات"
      }
    ]
  },
  {
    "key": "text_processing_comments",
    "text": "Processing Comments",
    "translations": [
      {
        "language": "AR",
        "text": "جاري تحميل التعليقات"
      }
    ]
  },
  {
    "key": "txtWokplaceOnboadingEx",
    "text": "Workplace Onboarding Experience By",
    "translations": [
      {
        "language": "EN",
        "text": "Workplace Onboarding Experience By"
      },
      {
        "language": "AR",
        "text": "تجربة الإعداد في مكان العمل حسب "
      }
    ]
  },
  {
    "key": "txtByBandLevel",
    "text": "Band Level",
    "translations": [
      {
        "language": "EN",
        "text": "Band Level"
      },
      {
        "language": "AR",
        "text": " المستوى الوظيفي"
      }
    ]
  },
  {
    "key": "BandLevel",
    "text": "Band Level",
    "translations": [
      {
        "language": "EN",
        "text": "Band Level"
      },
      {
        "language": "AR",
        "text": " المستوى الوظيفي"
      }
    ]
  },
  {
    "key": "txtByJobGrade",
    "text": "Job Grade",
    "translations": [
      {
        "language": "EN",
        "text": "Job Grade"
      },
      {
        "language": "AR",
        "text": " المستوى الوظيفي"
      }
    ]
  },
  {
    "key": "txtbygender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "  الجنس"
      },
      {
        "language": "FR",
        "text": " par Sexe"
      }
    ]
  },
  {
    "key": "txtbynationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": " الجنسية"
      },
      {
        "language": "FR",
        "text": " par Nationalité"
      }
    ]
  },
  {
    "key": "txt_by_generation",
    "text": "Generation",
    "translations": [
      {
        "language": "AR",
        "text": "  نوع الجيل"
      }
    ]
  },
  {
    "key": "txt_by_age_group",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": " الفئات العمرية"
      }
    ]
  },
  {
    "key": "txt_by_tenure_group",
    "text": "Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "  فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txt_NoteEnoughDataToShowResults",
    "text": "Not Enough Survey Responses to Show Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "لا توجد استجابات كافية لعرض التحليلات"
      }
    ]
  },
  {
    "key": "txtAtleastOneJoinerRequired",
    "text": "Total Joiners should be at least 1",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون عدد الموظفين الجدد 1 على الأقل"
      }
    ]
  },
  {
    "key": "txtNewCustomFactor",
    "text": "Custom Factor #",
    "translations": [
      {
        "language": "AR",
        "text": "عامل مخصص #"
      }
    ]
  },
  {
    "key": "txtNewCustomQuestion",
    "text": "Custom Statement#",
    "translations": [
      {
        "language": "AR",
        "text": "عبارة مخصصة #"
      }
    ]
  },
  {
    "key": "Total Joiners should be 1 at least",
    "text": "Total Joiners should be 1 at least",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون مجموع عدد المستجيبين 1 على الأقل"
      }
    ]
  },
  {
    "key": "OB:EXC09",
    "text": "No Rows Found",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم العثور على أي صفوف"
      }
    ]
  },
  {
    "key": "OB:EXC08",
    "text": "Error reading excel file or the data is in incorrect format",
    "translations": [
      {
        "language": "AR",
        "text": "يتعذر قراءة ملف الاكسل أو صياغة المعلومات المرفقة غير صحيحة"
      }
    ]
  },
  {
    "key": "OB:EXC07",
    "text": "Invalid Emails",
    "translations": [
      {
        "language": "AR",
        "text": "صياغة البريد الإلكتروني خاطئة"
      }
    ]
  },
  {
    "key": "OB:EXC01",
    "text": "Phase 1 Start date should be greater or equal to today",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون تاريخ بدء المرحلة الأولى موافق لليوم أو الأيام التي تليه"
      }
    ]
  },
  {
    "key": "OB:EXC02",
    "text": "Phase 2 Start date should be greater or equal to today",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون تاريخ بدء المرحلة الثانية موافق لليوم أو الأيام التي تليه"
      }
    ]
  },
  {
    "key": "OB:EXC03",
    "text": "Phase 1 End date should be less than or equal to today",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون تاريخ استكمال المرحلة الأولى موافق لليوم أو الأيام السابقة"
      }
    ]
  },
  {
    "key": "OB:EXC04",
    "text": "Phase 2 End date should be less than or equal to today",
    "translations": [
      {
        "language": "AR",
        "text": "يجب أن يكون تاريخ استكمال المرحلة الثانية موافق لليوم أو الأيام السابقة"
      }
    ]
  },
  {
    "key": "OB:EXC05",
    "text": "Phase 1 reminder dates are invalid",
    "translations": [
      {
        "language": "AR",
        "text": "تواريخ التذكير الخاصة بالمرحلة الأولى غير صالحة"
      }
    ]
  },
  {
    "key": "OB:EXC06",
    "text": "Phase 2 reminder dates are invalid",
    "translations": [
      {
        "language": "AR",
        "text": "تواريخ التذكير الخاصة بالمرحلة الثانية غير صالحة"
      }
    ]
  },
  {
    "key": "txtErrorExcelUpload",
    "text": "Kindly check the below errors in your uploaded excel data.",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى مراجعة التنبيهات المذكورة في ملف الاكسل المرفق"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      }
    ]
  },
  {
    "key": "txt_allocation_confirmation",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "FR",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      },
      {
        "language": "FR",
        "text": "#UNITS# les unités seront déduites pour cette action"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by ",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب "
      }
    ]
  },
  {
    "key": "txtRespondentsByBandLevel",
    "text": "Respondents by Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب المستوى الوظيفي"
      }
    ]
  },
  {
    "key": "txtRespbynationality",
    "text": "Respondents by Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنسية"
      },
      {
        "language": "FR",
        "text": "Répondants par Nationalité"
      }
    ]
  },
  {
    "key": "txtRespbygender",
    "text": "Respondents by Gender",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنس"
      },
      {
        "language": "FR",
        "text": "Répondants par Sexe"
      }
    ]
  },
  {
    "key": "txt_resp_by_generation",
    "text": "Respondents by Generation",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب نوع الجيل"
      }
    ]
  },
  {
    "key": "txt_resp_by_age_group",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الفئات العمرية"
      }
    ]
  },
  {
    "key": "txt_resp_by_tenure_group",
    "text": "Respondents by Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txtOverall",
    "text": "Overall",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      }
    ]
  },
  {
    "key": "txtDeleteQuestion",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      }
    ]
  },
  {
    "key": "txtAnonymous",
    "text": "Anonymous",
    "translations": [
      {
        "language": "AR",
        "text": "مجهول الهوية"
      }
    ]
  },
  {
    "key": "txtRespondents",
    "text": "Anonymous",
    "translations": [
      {
        "language": "AR",
        "text": "مستجيب"
      }
    ]
  },
  {
    "key": "txtPhaseTwoScore",
    "text": "Phase Two Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة المرحلة الثانية"
      }
    ]
  },
  {
    "key": "txtPhaseOneScore",
    "text": "Phase One Score",
    "translations": [
      {
        "language": "AR",
        "text": "درجة المرحلة الأولى"
      }
    ]
  },
  {
    "key": "txtTemplatehasbeendeleted",
    "text": "Template has been deleted",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف النموذج"
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      }
    ]
  },
  {
    "key": "txtStartSurvey",
    "text": "Start Survey",
    "translations": [
      {
        "language": "AR",
        "text": "ابدأ الاستبيان"
      }
    ]
  },
  {
    "key": "txtOf",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": "من"
      }
    ]
  },
  {
    "key": "txtN",
    "text": "n",
    "translations": [
      {
        "language": "AR",
        "text": "عدد الردود"
      }
    ]
  },
  {
    "key": "txt_MANAGERIAL",
    "text": "Managerial",
    "translations": [
      {
        "language": "AR",
        "text": "إداري"
      }
    ]
  },
  {
    "key": "txtOverallScore",
    "text": "Overall Score",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الكلية"
      }
    ]
  },
  {
    "key": "txtScore",
    "text": "Score",
    "translations": [
      {
        "language": "AR",
        "text": "نتيجة"
      }
    ]
  },
  {
    "key": "txtStatusAnalysis",
    "text": "Respondents by Status Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليل حالة المستجيبون"
      }
    ]
  },
  {
    "key": "txtSite",
    "text": "Site",
    "translations": [
      {
        "language": "AR",
        "text": "موقع"
      }
    ]
  },
  {
    "key": "txtDivision",
    "text": "Division",
    "translations": [
      {
        "language": "AR",
        "text": "قسم"
      }
    ]
  },
  {
    "key": "txtLeft",
    "text": "left",
    "translations": [
      {
        "language": "AR",
        "text": "متبقي"
      }
    ]
  },
  {
    "key": "txtLeftSeconds",
    "text": "seconds left",
    "translations": [
      {
        "language": "AR",
        "text": "ثانية متبقية"
      }
    ]
  },
  {
    "key": "txtRetry",
    "text": "Retry",
    "translations": [
      {
        "language": "AR",
        "text": "أعد المحاولة"
      }
    ]
  },
  {
    "key": "txtAbort",
    "text": "Abort",
    "translations": [
      {
        "language": "AR",
        "text": "إحباط"
      }
    ]
  },
  {
    "key": "txtSentOnly",
    "text": "Sent",
    "translations": [
      {
        "language": "AR",
        "text": "الإرسال"
      }
    ]
  },
  {
    "key": "txtDateOnly",
    "text": "Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ"
      }
    ]
  },
  {
    "key": "txtOnboardingSurveyIs",
    "text": "Onboarding survey is currently",
    "translations": [
      {
        "language": "AR",
        "text": "لاستبيان إعداد وتهيئة الموظفين "
      }
    ]
  },
  {
    "key": "txtSubmitEmployeePhaseOneSurvey",
    "text": "Please submit your Employee Onboarding Phase One survey first",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى إرسال استبيان المرحلة الأولى من إعداد الموظف الخاص بك أولاً"
      }
    ]
  },
  {
    "key": "txt_ReminderSent",
    "text": "Reminder has been sent",
    "translations": [
      {
        "language": "AR",
        "text": " تم إرسال التذكير"
      }
    ]
  },
  {
    "key": "txt_TemplateUpdated",
    "text": "Template Updated",
    "translations": [
      {
        "language": "AR",
        "text": " تم تحديث النموذج بنجاح"
      }
    ]
  },
  {
    "key": "txt_TemplateCreated",
    "text": "Template Created",
    "translations": [
      {
        "language": "AR",
        "text": " تم إنشاء النموذج"
      }
    ]
  },
  {
    "key": "txt_OF",
    "text": "of",
    "translations": [
      {
        "language": "AR",
        "text": " من"
      }
    ]
  },
  {
    "key": "txt_SuccessfullyAdded",
    "text": "has been added successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تمت الإضافة بنجاح"
      }
    ]
  },
  {
    "key": "txt_SuccessfullyEdited",
    "text": "has been edited successfully!",
    "translations": [
      {
        "language": "AR",
        "text": " تم التحديث بنجاح"
      }
    ]
  },
  {
    "key": "txt_Start&CompletionDates",
    "text": "Start and completion dates must be provided!",
    "translations": [
      {
        "language": "AR",
        "text": " يرجى إدخال تاريخ البدء والإكمال"
      }
    ]
  },
  {
    "key": "txt_FillFormCorrectly",
    "text": "Kindly fill the form correctly",
    "translations": [
      {
        "language": "AR",
        "text": "  يرجى تعبئة النموذج بشكل صحيح "
      }
    ]
  },
  {
    "key": "txt_required_field",
    "text": "This field is required",
    "translations": [
      {
        "language": "AR",
        "text": "هذا الحقل إجباري"
      },
      {
        "language": "FR",
        "text": "Ce champ est requis"
      }
    ]
  },
  {
    "key": "txt_phaseonecomplete",
    "text": "Please submit your Employee Onboarding Phase One survey first",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تسليم الاستبيان الأول الخاص بإعداد وتهيئة الموظفين، أولاً."
      }
    ]
  },
  {
    "key": "txt_joiner_q_welcome",
    "text": "Thank you for taking the time to fill out the Employee Onboarding survey. Your honest feedback is highly appreciated. <br> Please note that your responses are strictly confidential and are only used for research and improvement purposes by the Human Resources Team.",
    "translations": [
      {
        "language": "AR",
        "text": "نشكرك لمشاركتك في هذا الاستبيان. أجوبتك النزيهة والصريحة مهمة لنا. يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وتستخدم فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية."
      }
    ]
  },
  {
    "key": "txt_joiner_q_welcome_anonymous",
    "text": "Thank you for taking the time to fill out the Employee Onboarding survey. Your honest feedback is highly appreciated. <br> Please note that your responses are strictly confidential, and your identity shall remain anonymous throughout the entire process. <br> However, the results of the survey will be used for research and improvement purposes by the Human Resources Team. <br> Disclaimer: All information pertaining to this survey shall remain anonymous and shall not be disclosed to anyone",
    "translations": [
      {
        "language": "AR",
        "text": "نشكرك لمشاركتك في هذا الاستبيان. أجوبتك النزيهة والصريحة مهمة لنا. يرجى العلم بأن جميع النتائج التي سيتم الحصول عليها من هذا الاستبيان سرية للغاية وستبقى هويتك مجهولة.  وتستخدم هذه النتائج فقط لأغراض البحث والتطوير من قبل فريق الموارد البشرية. إخلاء المسؤولية: جميع المعلومات المتعلقة بهذا الاستبيان سرية ولن يتم الإفصاح عنها لأي جهة."
      }
    ]
  },
  {
    "key": "txt_Submit",
    "text": "Submit",
    "translations": [
      {
        "language": "EN",
        "text": "Submit"
      },
      {
        "language": "AR",
        "text": "يُقدِّم"
      }
    ]
  },
  {
    "key": "txt_Next",
    "text": "Next",
    "translations": [
      {
        "language": "EN",
        "text": "Next"
      },
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "txt_mangerial",
    "text": "Mangerial",
    "translations": [
      {
        "language": "EN",
        "text": "Mangerial"
      },
      {
        "language": "AR",
        "text": "المحترفين"
      }
    ]
  },
  {
    "key": "txt_Uploading",
    "text": "Uploading",
    "translations": [
      {
        "language": "EN",
        "text": "Uploading"
      },
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txt_spreadsheet",
    "text": "spreadsheet",
    "translations": [
      {
        "language": "EN",
        "text": "spreadsheet"
      },
      {
        "language": "AR",
        "text": "جدول"
      }
    ]
  },
  {
    "key": "txt_uploadthepremade",
    "text": "upload the premade",
    "translations": [
      {
        "language": "EN",
        "text": "upload the premade"
      },
      {
        "language": "AR",
        "text": "تحميل الجدول المُعرف مسبقاً"
      }
    ]
  },
  {
    "key": "txt_Downloadthepremade",
    "text": "Download the premade",
    "translations": [
      {
        "language": "EN",
        "text": "Download the premade"
      },
      {
        "language": "AR",
        "text": "تنزيل الجدول المُعرف مسبقاً"
      }
    ]
  },
  {
    "key": "txt_ValidateData",
    "text": "Validate Data",
    "translations": [
      {
        "language": "EN",
        "text": "Validate Data"
      },
      {
        "language": "AR",
        "text": "التحقق من صحة البيانات"
      }
    ]
  },
  {
    "key": "txt_TemplateUpload",
    "text": "Template Upload",
    "translations": [
      {
        "language": "EN",
        "text": "Template Upload"
      },
      {
        "language": "AR",
        "text": "تحميل النموذج"
      }
    ]
  },
  {
    "key": "txt_PopulateTemplate",
    "text": "Populate Template",
    "translations": [
      {
        "language": "EN",
        "text": "Populate Template"
      },
      {
        "language": "AR",
        "text": "تعبئة النموذج"
      }
    ]
  },
  {
    "key": "txt_TemplateDownload",
    "text": "Template Download",
    "translations": [
      {
        "language": "EN",
        "text": "Template Download"
      },
      {
        "language": "AR",
        "text": "تنزيل النموذج"
      }
    ]
  },
  {
    "key": "txt_EditTemplate",
    "text": "Edit Template",
    "translations": [
      {
        "language": "EN",
        "text": "Edit Template"
      },
      {
        "language": "AR",
        "text": "تعديل النموذج"
      }
    ]
  },
  {
    "key": "txt_NewTemplate",
    "text": "New Template",
    "translations": [
      {
        "language": "EN",
        "text": "New Template"
      },
      {
        "language": "AR",
        "text": "نموذج جديد"
      }
    ]
  },
  {
    "key": "txt_proceedWithPhaseTwoToDisplay",
    "text": "Evaluate your onboarding experience by adding a joiner",
    "translations": [
      {
        "language": "EN",
        "text": "Phase Two Survey must be submitted to show analysis"
      },
      {
        "language": "AR",
        "text": "يجب تسليم الاستبيان الخاص بالمرحلة الثانية لعرض التحليلات"
      }
    ]
  },
  {
    "key": "txt_EvaluateAddingJoiner",
    "text": "Evaluate your onboarding experience by adding a joiner",
    "translations": [
      {
        "language": "EN",
        "text": "Not enough joiners to display analysis"
      },
      {
        "language": "AR",
        "text": "لا توجد نتائج كافية لعرض نتائج التحليل"
      }
    ]
  },
  {
    "key": "txt_Notenoughjoinerstodisplay",
    "text": "Minimum 3 joiners should submit their answers to show analysis",
    "translations": [
      {
        "language": "EN",
        "text": "Not enough joiners to display."
      },
      {
        "language": "AR",
        "text": "يجب على ثلاثة مستجيبين كحد أدنى تقديم أجوبتهم لعرض نتائج التحليل"
      }
    ]
  },
  {
    "key": "txt_IncludeExtraFactors",
    "text": "Include Extra Factors",
    "translations": [
      {
        "language": "EN",
        "text": "Include Extra Factors"
      },
      {
        "language": "AR",
        "text": "قم بتضمين عوامل إضافية"
      }
    ]
  },
  {
    "key": "txt_PREDEFINEDTEMPLATES",
    "text": "PREDEFINED TEMPLATES",
    "translations": [
      {
        "language": "EN",
        "text": "PREDEFINED TEMPLATES"
      },
      {
        "language": "AR",
        "text": "نماذج مُعرفة مسبقاً"
      }
    ]
  },
  {
    "key": "txt_CUSTOMTEMPLATES",
    "text": "CUSTOM TEMPLATES",
    "translations": [
      {
        "language": "EN",
        "text": "CUSTOM TEMPLATES"
      },
      {
        "language": "AR",
        "text": "نماذج مخصصة"
      }
    ]
  },
  {
    "key": "txt_newValue",
    "text": "newValue",
    "translations": [
      {
        "language": "EN",
        "text": "newValue"
      },
      {
        "language": "AR",
        "text": "قيمة جديدة"
      }
    ]
  },
  {
    "key": "txt_MismatchedValue",
    "text": "Mismatched value",
    "translations": [
      {
        "language": "EN",
        "text": "Mismatched value"
      },
      {
        "language": "AR",
        "text": "قيمة غير مطابقة"
      }
    ]
  },
  {
    "key": "txt_PROFESSIONAL",
    "text": "Professional",
    "translations": [
      {
        "language": "EN",
        "text": "Professional"
      },
      {
        "language": "AR",
        "text": "مهني"
      }
    ]
  },
  {
    "key": "txt_SurveyOptions",
    "text": "Survey Options",
    "translations": [
      {
        "language": "EN",
        "text": "Survey Options"
      },
      {
        "language": "AR",
        "text": "خيارات الاستبيان"
      }
    ]
  },
  {
    "key": "txt_PositionInfo",
    "text": "Position Info",
    "translations": [
      {
        "language": "EN",
        "text": "Position Info"
      },
      {
        "language": "AR",
        "text": "المعلومات الوظيفية"
      }
    ]
  },
  {
    "key": "txt_PersonalInfo",
    "text": "Personal Info",
    "translations": [
      {
        "language": "EN",
        "text": "Personal Info"
      },
      {
        "language": "AR",
        "text": "المعلومات الشخصية"
      }
    ]
  },
  {
    "key": "txt_SendReminderOn",
    "text": "Send Reminder on:",
    "translations": [
      {
        "language": "EN",
        "text": "Send Reminder on:"
      },
      {
        "language": "AR",
        "text": "أرسل تذكير في"
      }
    ]
  },
  {
    "key": "txt_CompletionDate",
    "text": "Completion Date:",
    "translations": [
      {
        "language": "EN",
        "text": "Completion Date:"
      },
      {
        "language": "AR",
        "text": "تاريخ الإكمال"
      }
    ]
  },
  {
    "key": "txt_AnonymousSurvey",
    "text": "Anonymous survey",
    "translations": [
      {
        "language": "EN",
        "text": "Anonymous survey"
      },
      {
        "language": "AR",
        "text": "استبيان مجهول الهوية"
      }
    ]
  },
  {
    "key": "txt_DirectManagerName",
    "text": "Direct Manager Name",
    "translations": [
      {
        "language": "EN",
        "text": "Direct Manager Name"
      },
      {
        "language": "AR",
        "text": "اسم المدير المباشر"
      }
    ]
  },
  {
    "key": "txt_PhoneNumber",
    "text": "Phone Number",
    "translations": [
      {
        "language": "EN",
        "text": "Phone Number"
      },
      {
        "language": "AR",
        "text": "رقم الهاتف المحمول"
      }
    ]
  },
  {
    "key": "txt_JoinerEmail",
    "text": "Joiner Email",
    "translations": [
      {
        "language": "EN",
        "text": "Joiner Email"
      },
      {
        "language": "AR",
        "text": "البريد الإلكتروني "
      }
    ]
  },
  {
    "key": "txt_JoinerName",
    "text": "Joiner Name",
    "translations": [
      {
        "language": "EN",
        "text": "Joiner Name"
      },
      {
        "language": "AR",
        "text": "اسم الموظف "
      }
    ]
  },
  {
    "key": "txt_PhaseTwoEmployeeOnboardingFactors",
    "text": "Phase Two - Employee Onboarding Factors",
    "translations": [
      {
        "language": "EN",
        "text": "Phase Two - Employee Onboarding Factors"
      },
      {
        "language": "AR",
        "text": "عوامل المرحلة الأولى لاستبيان إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txt_PhaseOnEmployeeOnboardingFactors",
    "text": "Phase One - Employee Onboarding Factors",
    "translations": [
      {
        "language": "EN",
        "text": "Phase One - Employee Onboarding Factors"
      },
      {
        "language": "AR",
        "text": "عوامل المرحلة الثانية لاستبيان إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txt_INPROGRESS",
    "text": "In-progress",
    "translations": [
      {
        "language": "EN",
        "text": "In-progress"
      },
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      }
    ]
  },
  {
    "key": "txt_INACTIVE",
    "text": "Inactive",
    "translations": [
      {
        "language": "EN",
        "text": "Inactive"
      },
      {
        "language": "AR",
        "text": "غير فعَّال"
      }
    ]
  },
  {
    "key": "txt_COMPLETED",
    "text": "Completed",
    "translations": [
      {
        "language": "EN",
        "text": "Completed"
      },
      {
        "language": "AR",
        "text": "منجز"
      }
    ]
  },
  {
    "key": "txt_POSTED",
    "text": "Scheduled",
    "translations": [
      {
        "language": "EN",
        "text": "Scheduled"
      },
      {
        "language": "AR",
        "text": "مُجَدوَل"
      }
    ]
  },
  {
    "key": "txt_EXPIRED",
    "text": "Expired",
    "translations": [
      {
        "language": "EN",
        "text": "Expired"
      },
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      }
    ]
  },
  {
    "key": "txt_ALL",
    "text": "All",
    "translations": [
      {
        "language": "EN",
        "text": "All"
      },
      {
        "language": "AR",
        "text": "الكل"
      }
    ]
  },
  {
    "key": "Yearly",
    "text": "Yearly",
    "translations": [
      {
        "language": "EN",
        "text": "Yearly"
      },
      {
        "language": "AR",
        "text": "سنوي"
      }
    ]
  },
  {
    "key": "Quarterly",
    "text": "Quarterly",
    "translations": [
      {
        "language": "EN",
        "text": "Quarterly"
      },
      {
        "language": "AR",
        "text": "ربعي"
      }
    ]
  },
  {
    "key": "Monthly",
    "text": "Monthly",
    "translations": [
      {
        "language": "EN",
        "text": "Monthly"
      },
      {
        "language": "AR",
        "text": "شهريا"
      }
    ]
  },
  {
    "key": "txtWorkplaceExOvertime",
    "text": "Workplace Onboarding Experience Overtime By",
    "translations": [
      {
        "language": "EN",
        "text": "Workplace Onboarding Experience Overtime By"
      },
      {
        "language": "AR",
        "text": "تجربة الإعداد في مكان العمل على مدى الزمن "
      }
    ]
  },
  {
    "key": "JobGrade",
    "text": "Job Grade",
    "translations": [
      {
        "language": "EN",
        "text": "Job Grade"
      },
      {
        "language": "AR",
        "text": "الدرجة الوظيفية"
      }
    ]
  },
  {
    "key": "Gender",
    "text": "Gender",
    "translations": [
      {
        "language": "EN",
        "text": "Gender"
      },
      {
        "language": "AR",
        "text": "الجنس"
      }
    ]
  },
  {
    "key": "Nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "EN",
        "text": "Nationality"
      },
      {
        "language": "AR",
        "text": "الجنسية"
      }
    ]
  },
  {
    "key": "AgeGroup",
    "text": "Age Group",
    "translations": [
      {
        "language": "EN",
        "text": "Age Group"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب الفئات العمرية"
      }
    ]
  },
  {
    "key": "Generation",
    "text": "Generation",
    "translations": [
      {
        "language": "EN",
        "text": "Generation"
      },
      {
        "language": "AR",
        "text": "نوع الجيل"
      }
    ]
  },
  {
    "key": "txtUpdateTemplate",
    "text": "Update Template",
    "translations": [
      {
        "language": "EN",
        "text": "Update Template"
      },
      {
        "language": "AR",
        "text": "تحديث النموذج"
      }
    ]
  },
  {
    "key": "txtRespondentsByNationality",
    "text": "Respondents By Nationality",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents By Nationality"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنسية"
      }
    ]
  },
  {
    "key": "txtRespondentsByTenureGroups",
    "text": "Respondents By Tenure Groups",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents By Tenure Groups"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txtWokplaceOnboadingEx",
    "text": "Workplace Onboarding Experience By",
    "translations": [
      {
        "language": "EN",
        "text": "Workplace Onboarding Experience By"
      },
      {
        "language": "AR",
        "text": "تجربة الإعداد في مكان العمل حسب "
      }
    ]
  },
  {
    "key": "txtRespondentsBy",
    "text": "Respondents By",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents By"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب"
      }
    ]
  },
  {
    "key": "txtRespondentsByJobLevel",
    "text": "Respondents By Job Level",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents By Job Level"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب الدرجة الوظيفية"
      }
    ]
  },
  {
    "key": "txtRespondentsByJobGrade",
    "text": "Respondents By Job Grade",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents By Job Grade"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب الدرجة الوظيفية"
      }
    ]
  },
  {
    "key": "txtRespondentsByAgeGroups",
    "text": "Respondents By Age Groups",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents By Age Groups"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب الفئات العمرية"
      }
    ]
  },
  {
    "key": "txtRespondentsbyJobRole",
    "text": "Respondents by Job Role",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents by Job Role"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب الدور الوظيفي"
      }
    ]
  },
  {
    "key": "txtRespondentsbyOnboardingPhase",
    "text": "Respondents by Onboarding Phase",
    "translations": [
      {
        "language": "EN",
        "text": "Respondents by Onboarding Phase"
      },
      {
        "language": "AR",
        "text": "المستجيبون حسب مرحلة الإعداد والتهيئة للموظفين "
      }
    ]
  },
  {
    "key": "WorkplaceOnboardingExperienceByCriteria",
    "text": "Workplace Onboarding Experience By Criteria",
    "translations": [
      {
        "language": "EN",
        "text": "Workplace Onboarding Experience By Criteria"
      },
      {
        "language": "AR",
        "text": "تجربة الإعداد في مكان العمل حسب المعايير"
      }
    ]
  },
  {
    "key": "WorkplaceOnboardingExperienceOvertime",
    "text": "Workplace Onboarding Experience Overtime",
    "translations": [
      {
        "language": "EN",
        "text": "Workplace Onboarding Experience Overtime"
      },
      {
        "language": "AR",
        "text": "  تجربة الإعداد في مكان العمل على مدى الزمن"
      }
    ]
  },
  {
    "key": "B",
    "text": "b",
    "translations": [
      {
        "language": "EN",
        "text": "b"
      }
    ]
  },
  {
    "key": "R",
    "text": "r",
    "translations": [
      {
        "language": "EN",
        "text": "r"
      }
    ]
  },
  {
    "key": "A",
    "text": "a",
    "translations": [
      {
        "language": "EN",
        "text": "a"
      }
    ]
  },
  {
    "key": "C",
    "text": "c",
    "translations": [
      {
        "language": "EN",
        "text": "c"
      }
    ]
  },
  {
    "key": "E",
    "text": "e",
    "translations": [
      {
        "language": "EN",
        "text": "e"
      }
    ]
  },
  {
    "key": "Two",
    "text": "2",
    "translations": [
      {
        "language": "EN",
        "text": "2"
      }
    ]
  },
  {
    "key": "txtReportSen2",
    "text": "of Workplace Onboarding Experience at",
    "translations": [
      {
        "language": "EN",
        "text": "of Workplace Onboarding Experience at"
      },
      {
        "language": "AR",
        "text": "من تجربة الموظفين في مكان العمل في"
      }
    ]
  },
  {
    "key": "txtReportSen1",
    "text": "The below indicates the scores for each of the",
    "translations": [
      {
        "language": "EN",
        "text": "The below indicates the scores for each of the"
      },
      {
        "language": "AR",
        "text": "وتعرض أدناه نتائج لكل من"
      }
    ]
  },
  {
    "key": "txtOnboardingNewEmployees",
    "text": "<p> Profound research has shown that the process of onboarding new employees depends on several elements, like security, connection, consistency, and progression, for a new employee to have a good onboarding experience. <br> <br> Zenithr's team has designed the BRACE model and factors influencing the employee's onboarding experience according to the latest research and evidence-based practices in the industry. <br> <br> BRACE stands for Belonging, Role Clarity, Adaptability, Continuity, and Efficacy; each of these factors measure the effectiveness of onboarding, which helps dive into the reasons behind a good or poor onboarding experience and diagnose the effectiveness of the onboarding based on the impressions of new employees.</p>",
    "translations": [
      {
        "language": "EN",
        "text": "<p> Profound research has shown that the process of onboarding new employees depends on several elements, like security, connection, consistency, and progression, for a new employee to have a good onboarding experience. <br> Zenithr's team has designed the BRACE model and factors influencing the employee's onboarding experience according to the latest research and evidence-based practices in the industry. <br> BRACE stands for Belonging, Role Clarity, Adaptability, Continuity, and Efficacy; each of these factors measure the effectiveness of onboarding, which helps dive into the reasons behind a good or poor onboarding experience and diagnose the effectiveness of the onboarding based on the impressions of new employees.</p>"
      },
      {
        "language": "AR",
        "text": "<p> أظهرت الأبحاث المتعمقة أن عملية إعداد وتهيئة الموظفين الجدد ترتكز على عدة عوامل متمثلة في توفير الأمن والحماية، والتواصل الجيد في نطاق العمل، والاتساق والاستقرار في نظام العمل، ودعم التقدم الوظيفي بشكل مستمر للموظف الجديد، ليتمكن من الحصول على تجربة إعداد وتهيئة جيدة.  <br>  قام فريق عمل زينثر بتصميم نموذج (BRACE)  وتوفير العوامل التي من شأنها التأثير على عملية إعداد وتهيئة الموظف وفقاً لمعايير أحدث الأبحاث والممارسات القائمة على الأدلة في مجال الصناعة. <br> يشير مصطلح (BRACE) إلى الانتماء، ووضوح الدور الوظيفي، والقدرة على التكيف، والاستمرارية في العمل، و كفاءة الموظف. حيث يقيس كل عامل من تلك العوامل مدى فعالية إعداد وتهيئة الموظف، وما يترتب على ذلك من إمكانية القيام ببحث متعمق يوضح الأسباب التي تكمن وراء نجاح أو فشل تجربة إعداد وتهيئة الموظفين الجدد، وكذلك تحديد مدى فعالية تلك التجربة استناداً إلى انطباعات الموظفين الجدد.<p>"
      }
    ]
  },
  {
    "key": "txtManagerialQuestion",
    "text": "Managerial Question",
    "translations": [
      {
        "language": "EN",
        "text": "Managerial Question"
      },
      {
        "language": "AR",
        "text": "سؤال إداري"
      }
    ]
  },
  {
    "key": "txtCreateTemplate",
    "text": "Create Template",
    "translations": [
      {
        "language": "EN",
        "text": "Create Template"
      },
      {
        "language": "AR",
        "text": "أنشئ نموذج"
      }
    ]
  },
  {
    "key": "txtHideIndividualResponses",
    "text": "Hide individual responses from admins and reviewer ",
    "translations": [
      {
        "language": "EN",
        "text": "Hide individual responses from admins and reviewer "
      },
      {
        "language": "AR",
        "text": "إخفاء إجابات المستجيبون من المستخدمين والمراجعين"
      }
    ]
  },
  {
    "key": "txtSurveyAnonymity",
    "text": "Survey Anonymity",
    "translations": [
      {
        "language": "EN",
        "text": "Survey Anonymity"
      },
      {
        "language": "AR",
        "text": "استبيان مجهول الهوية"
      }
    ]
  },
  {
    "key": "txtQUESTIONS2",
    "text": "Statements",
    "translations": [
      {
        "language": "EN",
        "text": "Statements"
      },
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtQuestionAdded",
    "text": "At least one statement needs to be added!",
    "translations": [
      {
        "language": "EN",
        "text": "At least one statement needs to be added!"
      },
      {
        "language": "AR",
        "text": "يجب إضافة عبارة واحدة على الأقل!"
      }
    ]
  },
  {
    "key": "txtNewQuestion",
    "text": "New Statement",
    "translations": [
      {
        "language": "EN",
        "text": "New Statement"
      },
      {
        "language": "AR",
        "text": "عبارة جديدة"
      }
    ]
  },
  {
    "key": "txtNewFactor",
    "text": "New Factor",
    "translations": [
      {
        "language": "EN",
        "text": "New Factor"
      },
      {
        "language": "AR",
        "text": "عامل جديد"
      }
    ]
  },
  {
    "key": "txtUsingModel",
    "text": "Using Model",
    "translations": [
      {
        "language": "EN",
        "text": "Using Model"
      },
      {
        "language": "AR",
        "text": "باستخدام نموذج"
      }
    ]
  },
  {
    "key": "txtSinglePhase",
    "text": "Single-Phased Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان الإعداد ذو المرحلة الواحدة"
      }
    ]
  },
  {
    "key": "txtSinglePhasedReport",
    "text": "Single-phased",
    "translations": [
      {
        "language": "AR",
        "text": "المرحلة الواحدة"
      }
    ]
  },
  {
    "key": "txtSinglePhased",
    "text": "Single-phased",
    "translations": [
      {
        "language": "AR",
        "text": "على مرحلة واحدة"
      }
    ]
  },
  {
    "key": "txtOnboardingSurveyPreview",
    "text": "Onboarding Survey Preview",
    "translations": [
      {
        "language": "EN",
        "text": "Onboarding Survey Preview"
      },
      {
        "language": "AR",
        "text": "عرض استبيان إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "RECOMMENDED",
    "text": "RECOMMENDED",
    "translations": [
      {
        "language": "EN",
        "text": "RECOMMENDED"
      },
      {
        "language": "AR",
        "text": "موصى به"
      }
    ]
  },
  {
    "key": "txtTwoPhased",
    "text": "Two-phased",
    "translations": [
      {
        "language": "EN",
        "text": "Two-phased"
      },
      {
        "language": "AR",
        "text": "ذو المرحلتين"
      }
    ]
  },
  {
    "key": "txtFirstPhase",
    "text": "Phase One Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Phase One Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان الإعداد للمرحلة الأولى"
      }
    ]
  },
  {
    "key": "txtSecondPhase",
    "text": "Phase Two Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Phase Two Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان الإعداد للمرحلة الثانية"
      }
    ]
  },
  {
    "key": "txtDeleteTemplate",
    "text": "Delete Template",
    "translations": [
      {
        "language": "EN",
        "text": "Delete Template"
      },
      {
        "language": "AR",
        "text": "حذف النموذج"
      }
    ]
  },
  {
    "key": "txtEditTemplate",
    "text": "Edit Template",
    "translations": [
      {
        "language": "EN",
        "text": "Edit Template"
      },
      {
        "language": "AR",
        "text": "تعديل النموذج"
      }
    ]
  },
  {
    "key": "txtExportTemplate",
    "text": "Export Template",
    "translations": [
      {
        "language": "EN",
        "text": "Export Template"
      },
      {
        "language": "AR",
        "text": "تحميل النموذج"
      }
    ]
  },
  {
    "key": "txtUnsaved",
    "text": "Unsaved",
    "translations": [
      {
        "language": "EN",
        "text": "Unsaved"
      },
      {
        "language": "AR",
        "text": "لم يتم الحفظ"
      }
    ]
  },
  {
    "key": "txtSaved",
    "text": "Saved",
    "translations": [
      {
        "language": "EN",
        "text": "Saved"
      },
      {
        "language": "AR",
        "text": "تم الحفظ"
      }
    ]
  },
  {
    "key": "txtNotEditTemplate",
    "text": "Predefined templates can not be edited",
    "translations": [
      {
        "language": "EN",
        "text": "Predefined templates can not be edited"
      },
      {
        "language": "AR",
        "text": "لا يمكن تعديل النماذج المُعرفة مسبقاً"
      }
    ]
  },
  {
    "key": "txtNotEditLockedTemplate",
    "text": "Used templates can not be edited",
    "translations": [
      {
        "language": "EN",
        "text": "Used templates can not be edited"
      },
      {
        "language": "AR",
        "text": "لا يمكن تعديل النماذج المستخدمه"
      }
    ]
  },
  {
    "key": "txtReminderEmailTemplate",
    "text": "Reminder Email Template",
    "translations": [
      {
        "language": "EN",
        "text": "Reminder Email Template"
      },
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني للتذكير"
      }
    ]
  },
  {
    "key": "txtInvitationEmailTemplate",
    "text": "Invitation Email Template",
    "translations": [
      {
        "language": "EN",
        "text": "Invitation Email Template"
      },
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني للدعوة"
      }
    ]
  },
  {
    "key": "txtEmailTemplates",
    "text": "Email Templates",
    "translations": [
      {
        "language": "EN",
        "text": "Email Templates"
      },
      {
        "language": "AR",
        "text": "نماذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "txt_add_reminder",
    "text": "Add Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة تذكير"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Rappel"
      }
    ]
  },
  {
    "key": "txtAutomatedReminders",
    "text": "Automated Reminders",
    "translations": [
      {
        "language": "EN",
        "text": "Automated Reminders"
      },
      {
        "language": "AR",
        "text": "ضبط التذكيرات"
      }
    ]
  },
  {
    "key": "txtDisableOption",
    "text": "(For better analysis we recommend to Disable this option)",
    "translations": [
      {
        "language": "EN",
        "text": "(For better analysis we recommend to Disable this option)"
      },
      {
        "language": "AR",
        "text": "(لتحليل أفضل نوصي بتعطيل هذا الخيار)"
      }
    ]
  },
  {
    "key": "txtHideResponses",
    "text": "Hide individual responses from admins and reviewer",
    "translations": [
      {
        "language": "EN",
        "text": "Hide individual responses from admins and reviewer"
      },
      {
        "language": "AR",
        "text": "إخفاء إجابات المستجيبين من المستخدمين والمراجعين"
      }
    ]
  },
  {
    "key": "Template",
    "text": "Template",
    "translations": [
      {
        "language": "EN",
        "text": "Template"
      },
      {
        "language": "AR",
        "text": "النموذج"
      }
    ]
  },
  {
    "key": "txtErrorFIX",
    "text": "Fix the above errors, <br> then <strong>Save Changes</strong> to continue",
    "translations": [
      {
        "language": "EN",
        "text": "Fix the above errors, <br> then <strong>Save Changes</strong> to continue"
      },
      {
        "language": "AR",
        "text": "قم بتصليح الأخطاء المذكورة أعلاه <br> ثم <strong> قم بحفظ التغييرات <strong> للمتابعة"
      }
    ]
  },
  {
    "key": "txtSaveChanges",
    "text": "Save Changes",
    "translations": [
      {
        "language": "EN",
        "text": "Save Changes"
      },
      {
        "language": "AR",
        "text": "حفظ التغييرات"
      }
    ]
  },
  {
    "key": "txtCase",
    "text": "CASE",
    "translations": [
      {
        "language": "EN",
        "text": "CASE"
      },
      {
        "language": "AR",
        "text": "حالة"
      }
    ]
  },
  {
    "key": "txtTotalErrors",
    "text": "Total Errors",
    "translations": [
      {
        "language": "EN",
        "text": "Total Errors"
      },
      {
        "language": "AR",
        "text": "إجمالي الأخطاء"
      }
    ]
  },
  {
    "key": "txtThree",
    "text": "3",
    "translations": [
      {
        "language": "EN",
        "text": "3"
      },
      {
        "language": "AR",
        "text": "3"
      }
    ]
  },
  {
    "key": "TABLECOLUMNS",
    "text": "TABLE COLUMNS",
    "translations": [
      {
        "language": "EN",
        "text": "TABLE COLUMNS"
      },
      {
        "language": "AR",
        "text": "أعمدة الجدول"
      }
    ]
  },
  {
    "key": "txtFixValidationError",
    "text": "Please fix the data validation errors below to Continue",
    "translations": [
      {
        "language": "EN",
        "text": "Please fix the data validation errors below to Continue"
      },
      {
        "language": "AR",
        "text": "يرجى تصحيح أخطاء التحقق من صحة البيانات أدناه للمتابعة"
      }
    ]
  },
  {
    "key": "txtSpreadUploadOnce",
    "text": "once the spreadsheet is uploaded!",
    "translations": [
      {
        "language": "EN",
        "text": "once the spreadsheet is uploaded!"
      },
      {
        "language": "AR",
        "text": "عند تحميل جدول البيانات!"
      }
    ]
  },
  {
    "key": "txtReviewData",
    "text": "Review Data",
    "translations": [
      {
        "language": "EN",
        "text": "Review Data"
      },
      {
        "language": "AR",
        "text": "مراجعة البيانات"
      }
    ]
  },
  {
    "key": "txtFilledTemplates",
    "text": "Upload the filled template",
    "translations": [
      {
        "language": "EN",
        "text": "Upload the filled template"
      },
      {
        "language": "AR",
        "text": "قم بتحميل نموذج المعبأ"
      }
    ]
  },
  {
    "key": "txtFilledDownloadedTemplates",
    "text": "after you've filled the downloaded template and saved it to be uploaded.",
    "translations": [
      {
        "language": "EN",
        "text": "after you've filled the downloaded template and saved it to be uploaded."
      },
      {
        "language": "AR",
        "text": "قم بتحميل النموذج المعبأ  والذي تم حفظه"
      }
    ]
  },
  {
    "key": "txtClick",
    "text": "Click",
    "translations": [
      {
        "language": "EN",
        "text": "Click"
      },
      {
        "language": "AR",
        "text": "اضغط على"
      }
    ]
  },
  {
    "key": "txtUploadNextStep",
    "text": "the file to be uploaded on the next step",
    "translations": [
      {
        "language": "EN",
        "text": "the file to be uploaded on the next step"
      },
      {
        "language": "AR",
        "text": "قم بتحميل الملف بالخطوة التالية"
      }
    ]
  },
  {
    "key": "txtSave",
    "text": "Save",
    "translations": [
      {
        "language": "EN",
        "text": "Save"
      },
      {
        "language": "AR",
        "text": "حفظ"
      }
    ]
  },
  {
    "key": "txtDeleteExample",
    "text": "Note: Please delete the example row",
    "translations": [
      {
        "language": "EN",
        "text": "Note: Please delete the example row"
      },
      {
        "language": "AR",
        "text": "ملاحظة: يرجى حذف صف المثال"
      }
    ]
  },
  {
    "key": "txtPremadeStructure",
    "text": "the data without altering the premade structure of the template or changing the file extension (.xlsx)",
    "translations": [
      {
        "language": "EN",
        "text": "the data without altering the premade structure of the template or changing the file extension (.xlsx)"
      },
      {
        "language": "AR",
        "text": "البيانات دون تغيير النموذج المعُرف مسبقاً أو تغيير نوع الملف (.xlsx)"
      }
    ]
  },
  {
    "key": "txtFill",
    "text": "Fill",
    "translations": [
      {
        "language": "EN",
        "text": "Fill"
      },
      {
        "language": "AR",
        "text": "قم بتعبئة"
      }
    ]
  },
  {
    "key": "txtSpreadsheetEditor",
    "text": "the template with your spreadsheet editor i.e. Microsoft Excel",
    "translations": [
      {
        "language": "EN",
        "text": "the template with your spreadsheet editor i.e. Microsoft Excel"
      },
      {
        "language": "AR",
        "text": "النموذج باستخدام تطبيق يعدل جدول البيانات مثل  Microsoft Excel"
      }
    ]
  },
  {
    "key": "txtSaveaSpreadsheet",
    "text": "to save a spreadsheet file on your computer first.",
    "translations": [
      {
        "language": "EN",
        "text": "to save a spreadsheet file on your computer first."
      },
      {
        "language": "AR",
        "text": "لحفظ ملف جدول البيانات على جهاز الكبيوتر الخاص بك"
      }
    ]
  },
  {
    "key": "txtDownloadTemplate",
    "text": "Template Download",
    "translations": [
      {
        "language": "AR",
        "text": "تنزيل النموذج"
      }
    ]
  },
  {
    "key": "txtUploadTemplate",
    "text": "Upload Template",
    "translations": [
      {
        "language": "EN",
        "text": "Upload Template"
      },
      {
        "language": "AR",
        "text": "تحميل النموذج"
      }
    ]
  },
  {
    "key": "txtClickon",
    "text": "Click on",
    "translations": [
      {
        "language": "EN",
        "text": "Click on"
      },
      {
        "language": "AR",
        "text": "اضغط على"
      }
    ]
  },
  {
    "key": "txtaddmultiplejoinerstotheplatform",
    "text": "You can add multiple joiners to the platform at once using a premade spreadsheet template (.xlsx) file, it contains all the required and optional fields that can be filled with your own data.",
    "translations": [
      {
        "language": "EN",
        "text": "You can add multiple joiners to the platform at once using a premade spreadsheet template (.xlsx) file, it contains all the required and optional fields that can be filled with your own data."
      },
      {
        "language": "AR",
        "text": "يمكنك إضافة العديد من الموظفين الجدد باستخدام جدول البيانات المُعرف مسبقاً (.xlsx) وهو يتضمن جميع المعلومات المطلوبة والتي يتطلب منك بتعبئتها"
      }
    ]
  },
  {
    "key": "txtSendReminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "EN",
        "text": "Send Reminder"
      },
      {
        "language": "AR",
        "text": "أرسل تذكير"
      }
    ]
  },
  {
    "key": "txtJoinerAnswerReport",
    "text": "Joiner Answer Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير أجوبة الموظف الجديد"
      }
    ]
  },
  {
    "key": "txtTwoPhaseOnboardingSurvey",
    "text": "Two Phase Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Two Phase Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان إعداد وتهيئة الموظفين ذو المرحلتين"
      }
    ]
  },
  {
    "key": "txtSinglePhaseOnboardingSurvey",
    "text": "Single Phase Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Single Phase Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان إعداد وتهيئة الموظفين ذو المرحلة الواحدة"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaires"
      }
    ]
  },
  {
    "key": "btn_joiner_list_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "txtSendReminders",
    "text": "Send Reminders",
    "translations": [
      {
        "language": "EN",
        "text": "Send Reminders"
      },
      {
        "language": "AR",
        "text": "أرسل تذكيرات"
      }
    ]
  },
  {
    "key": "txtJobRole",
    "text": "Job Role",
    "translations": [
      {
        "language": "EN",
        "text": "Job Role"
      },
      {
        "language": "AR",
        "text": "الدور الوظيفي"
      }
    ]
  },
  {
    "key": "txtPhaseTwoDeadline",
    "text": "Phase Two Deadline",
    "translations": [
      {
        "language": "EN",
        "text": "Phase Two Deadline"
      },
      {
        "language": "AR",
        "text": "تاريخ اتمام المرحلة الثانية"
      }
    ]
  },
  {
    "key": "txtPhaseOneDeadline",
    "text": "Phase One Deadline",
    "translations": [
      {
        "language": "EN",
        "text": "Phase One Deadline"
      },
      {
        "language": "AR",
        "text": "تاريخ اتمام المرحلة الأولى"
      }
    ]
  },
  {
    "key": "txtSinglePhaseDeadline",
    "text": "Survey Deadline",
    "translations": [
      {
        "language": "EN",
        "text": "Survey Deadline"
      },
      {
        "language": "AR",
        "text": "تاريخ اتمام الاستبيان  "
      }
    ]
  },
  {
    "key": "txtMeanScore",
    "text": "Mean Score",
    "translations": [
      {
        "language": "EN",
        "text": "Mean Score"
      },
      {
        "language": "AR",
        "text": "المتوسط"
      }
    ]
  },
  {
    "key": "txtFactorScore",
    "text": "Factors' Score",
    "translations": [
      {
        "language": "EN",
        "text": "Factors' Score"
      },
      {
        "language": "AR",
        "text": "درجة العوامل"
      }
    ]
  },
  {
    "key": "txtDefinitiongoeshere",
    "text": "Definition goes here! Definition goes here! Definition goes here!",
    "translations": [
      {
        "language": "EN",
        "text": "Definition goes here! Definition goes here! Definition goes here!"
      },
      {
        "language": "AR",
        "text": "تجربة الإعداد والتهيئة للموظفين الجدد في مكان العمل "
      }
    ]
  },
  {
    "key": "txtWorkEXP",
    "text": "Workplace Onboarding Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Workplace Onboarding Experience"
      },
      {
        "language": "AR",
        "text": " تجربة الإعداد والتهيئة في مكان العمل"
      }
    ]
  },
  {
    "key": "txtOnBoarding",
    "text": "Onboarding",
    "translations": [
      {
        "language": "EN",
        "text": "Onboarding"
      },
      {
        "language": "AR",
        "text": "إعداد وتهيئة"
      }
    ]
  },
  {
    "key": "txtAllRights",
    "text": "All Rights Reserved",
    "translations": [
      {
        "language": "AR",
        "text": "جميع الحقوق محفوظة"
      },
      {
        "language": "FR",
        "text": "Tous les droits sont réservés"
      }
    ]
  },
  {
    "key": "txtGenerated",
    "text": "Generated",
    "translations": [
      {
        "language": "AR",
        "text": "تم إنشاءه في"
      },
      {
        "language": "FR",
        "text": "Créé  "
      }
    ]
  },
  {
    "key": "txtDriver/Question",
    "text": "Factor / Statement",
    "translations": [
      {
        "language": "EN",
        "text": "Factor / Statement"
      },
      {
        "language": "AR",
        "text": "عامل / عبارة"
      }
    ]
  },
  {
    "key": "txt1",
    "text": "1",
    "translations": [
      {
        "language": "EN",
        "text": "1"
      },
      {
        "language": "AR",
        "text": "1"
      }
    ]
  },
  {
    "key": "txtScienceBehindtheBRACEModel",
    "text": "Science Behind the BRACE Model",
    "translations": [
      {
        "language": "EN",
        "text": "Science Behind the BRACE Model"
      },
      {
        "language": "AR",
        "text": "الهدف العلمي وراء استخدام نموذج BRACE"
      }
    ]
  },
  {
    "key": "txtPhaseTwo",
    "text": "Phase Two",
    "translations": [
      {
        "language": "AR",
        "text": "المرحلة الثانية"
      }
    ]
  },
  {
    "key": "txtPhaseOneSurvey",
    "text": "Phase One",
    "translations": [
      {
        "language": "EN",
        "text": "Phase One"
      },
      {
        "language": "AR",
        "text": "المرحلة الأولى"
      }
    ]
  },
  {
    "key": "txtPhaseTwoSurvey",
    "text": "Phase Two",
    "translations": [
      {
        "language": "AR",
        "text": "المرحلة الثانية"
      }
    ]
  },
  {
    "key": "txtPhaseOne",
    "text": "Phase One",
    "translations": [
      {
        "language": "EN",
        "text": "Phase One"
      },
      {
        "language": "AR",
        "text": "المرحلة الأولى"
      }
    ]
  },
  {
    "key": "txtOnboardingPhase",
    "text": "Onboarding Phase",
    "translations": [
      {
        "language": "EN",
        "text": "Onboarding Phase"
      },
      {
        "language": "AR",
        "text": "مرحلة إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txtTemplateName",
    "text": "Template Name",
    "translations": [
      {
        "language": "EN",
        "text": "Template Name"
      },
      {
        "language": "AR",
        "text": "اسم النموذج"
      }
    ]
  },
  {
    "key": "txtShowMoreComment",
    "text": "Show More Comments",
    "translations": [
      {
        "language": "EN",
        "text": "Show More Comments"
      },
      {
        "language": "AR",
        "text": "إظهار المزيد من التعليقات"
      }
    ]
  },
  {
    "key": "txtApply",
    "text": "Apply",
    "translations": [
      {
        "language": "AR",
        "text": "تطبيق"
      }
    ]
  },
  {
    "key": "txtSelected",
    "text": "Selected",
    "translations": [
      {
        "language": "AR",
        "text": "المختارة"
      },
      {
        "language": "FR",
        "text": "Choisi"
      }
    ]
  },
  {
    "key": "txtPeople",
    "text": "Respondents",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون"
      },
      {
        "language": "FR",
        "text": "Répondants"
      }
    ]
  },
  {
    "key": "txtSelectEntity",
    "text": "Selected Entity",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة"
      }
    ]
  },
  {
    "key": "txtViewBy",
    "text": "View By",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح عن طريق"
      }
    ]
  },
  {
    "key": "txtExport",
    "text": "Export",
    "translations": [
      {
        "language": "EN",
        "text": "Export"
      },
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "txtAnalysisSection",
    "text": "Analysis",
    "translations": [
      {
        "language": "EN",
        "text": "Analysis"
      },
      {
        "language": "AR",
        "text": "تحليلات"
      }
    ]
  },
  {
    "key": "txtSwitchTemplate",
    "text": "SWITCH TEMPLATE",
    "translations": [
      {
        "language": "EN",
        "text": "SWITCH TEMPLATE"
      },
      {
        "language": "AR",
        "text": "اختر نموذج"
      }
    ]
  },
  {
    "key": "txtJoinersByStatus",
    "text": "JOINERS BY STATUS",
    "translations": [
      {
        "language": "EN",
        "text": "JOINERS BY STATUS"
      },
      {
        "language": "AR",
        "text": "الموظفين الجدد حسب الحالة"
      }
    ]
  },
  {
    "key": "txt_delete_confirmation_subject",
    "text": "Confirmation",
    "translations": [
      {
        "language": "AR",
        "text": "تأكيد"
      },
      {
        "language": "FR",
        "text": "Confirmation"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      }
    ]
  },
  {
    "key": "txt_delete_item_confirmation_message",
    "text": "Are you sure you want to permanently remove this item?",
    "translations": [
      {
        "language": "EN",
        "text": "Are you sure you want to permanently remove this item?"
      },
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد حذف هذا العنصر نهائياً؟ "
      }
    ]
  },
  {
    "key": "txt_delete_joiner_confirmation_message",
    "text": "Are you sure you want to delete this joiner?",
    "translations": [
      {
        "language": "EN",
        "text": "Are you sure you want to delete this joiner?"
      },
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد من حذف الموظف الجديد؟"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "EN",
        "text": "Overview"
      },
      {
        "language": "AR",
        "text": "نظرة عامة"
      }
    ]
  },
  {
    "key": "txtJoinerAnalysis",
    "text": "Joiner's Analysis",
    "translations": [
      {
        "language": "EN",
        "text": "Joiner's Analysis"
      },
      {
        "language": "AR",
        "text": "تحليلات الموظفين الجدد"
      }
    ]
  },
  {
    "key": "txtQuestions",
    "text": "Statements",
    "translations": [
      {
        "language": "EN",
        "text": "Statements"
      },
      {
        "language": "AR",
        "text": "العبارات"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "EN",
        "text": "Comments"
      },
      {
        "language": "AR",
        "text": "التعليقات"
      }
    ]
  },
  {
    "key": "txtOnboarding",
    "text": "Employee Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Employee Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "VERYPOOREXP",
    "text": "Very Poor Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Very Poor Experience"
      },
      {
        "language": "AR",
        "text": "تجربة سيئة للغاية"
      }
    ]
  },
  {
    "key": "POOREXP",
    "text": "Poor Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Poor Experience"
      },
      {
        "language": "AR",
        "text": "تجربة سيئة "
      }
    ]
  },
  {
    "key": "FAIREXP",
    "text": "Fair Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Fair Experience"
      },
      {
        "language": "AR",
        "text": "تجربة معتدلة"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "Good Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Good Experience"
      },
      {
        "language": "AR",
        "text": "تجربة جيدة"
      }
    ]
  },
  {
    "key": "VERYGOODEXP",
    "text": "Very Good Experience",
    "translations": [
      {
        "language": "EN",
        "text": "Very Good Experience"
      },
      {
        "language": "AR",
        "text": "تجربة جيدة للغاية"
      }
    ]
  },
  {
    "key": "txt_no_comments",
    "text": "No Comments.",
    "translations": [
      {
        "language": "EN",
        "text": "No Comments."
      },
      {
        "language": "AR",
        "text": "لا يوجد تعليقات."
      }
    ]
  },
  {
    "key": "txt_survey_title",
    "text": "Employee Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Employee Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txtList",
    "text": "Joiner's List",
    "translations": [
      {
        "language": "EN",
        "text": "Joiner's List"
      },
      {
        "language": "AR",
        "text": "قائمة الموظفين الجدد"
      }
    ]
  },
  {
    "key": "txtTemplate",
    "text": "Survey Templates",
    "translations": [
      {
        "language": "EN",
        "text": "Survey Templates"
      },
      {
        "language": "AR",
        "text": "نماذج الاستبيان"
      }
    ]
  },
  {
    "key": "txtAnalytics",
    "text": "Analytics",
    "translations": [
      {
        "language": "EN",
        "text": "Analytics"
      },
      {
        "language": "AR",
        "text": "التحليلات"
      }
    ]
  },
  {
    "key": "txt2nd",
    "text": "2nd",
    "translations": [
      {
        "language": "EN",
        "text": "2nd"
      },
      {
        "language": "AR",
        "text": "الثاني"
      }
    ]
  },
  {
    "key": "txt1st",
    "text": "1st",
    "translations": [
      {
        "language": "EN",
        "text": "1st"
      },
      {
        "language": "AR",
        "text": "الأول"
      }
    ]
  },
  {
    "key": "single1Start",
    "text": "Single-Phase Start Date",
    "translations": [
      {
        "language": "EN",
        "text": "Single-Phase Start Date"
      },
      {
        "language": "AR",
        "text": "تاريخ بدء على مرحلة واحدة "
      }
    ]
  },
  {
    "key": "phase1Start",
    "text": "Phase One Start Date",
    "translations": [
      {
        "language": "EN",
        "text": "Phase One start date"
      },
      {
        "language": "AR",
        "text": "تاريخ بدء المرحلة الأولى"
      }
    ]
  },
  {
    "key": "phase2Start",
    "text": "Phase Two Start Date",
    "translations": [
      {
        "language": "EN",
        "text": "Phase Two start date"
      },
      {
        "language": "AR",
        "text": "تاريخ بدء المرحلة الثانية"
      }
    ]
  },
  {
    "key": "txtSurveyUnavailable",
    "text": "Survey Unavailable",
    "translations": [
      {
        "language": "EN",
        "text": "Survey Unavailable"
      },
      {
        "language": "AR",
        "text": "الاستبيان غير متاح"
      }
    ]
  },
  {
    "key": "txt_employee_OnboardingSurvey",
    "text": "Employee Onboarding Survey",
    "translations": [
      {
        "language": "EN",
        "text": "Employee Onboarding Survey"
      },
      {
        "language": "AR",
        "text": "استبيان إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txtClearTimeFrame",
    "text": "Clear Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "إزالة المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Effacer a délai"
      }
    ]
  },
  {
    "key": "txtFindjoiners",
    "text": "Search joiners...",
    "translations": [
      {
        "language": "AR",
        "text": "ابحث عن موظف..."
      },
      {
        "language": "FR",
        "text": "Rechercher des Répondants "
      }
    ]
  },
  {
    "key": "txtOpen",
    "text": "Open",
    "translations": [
      {
        "language": "AR",
        "text": "فتح"
      }
    ]
  },
  {
    "key": "txtDashboard",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      }
    ]
  },
  {
    "key": "txtTotal",
    "text": "Total ",
    "translations": [
      {
        "language": "AR",
        "text": "المجموع"
      },
      {
        "language": "FR",
        "text": "Total "
      }
    ]
  },
  {
    "key": "txtTo",
    "text": "To ",
    "translations": [
      {
        "language": "AR",
        "text": "إلى"
      }
    ]
  },
  {
    "key": "btn_add",
    "text": "Add",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة"
      },
      {
        "language": "FR",
        "text": "Ajouter"
      }
    ]
  },
  {
    "key": "btn_joiner_list_delete",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "حذف"
      },
      {
        "language": "FR",
        "text": "Supprimer"
      }
    ]
  },
  {
    "key": "txtEntity",
    "text": "Entity",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité "
      }
    ]
  },
  {
    "key": "txtReportsto",
    "text": "Reports to",
    "translations": [
      {
        "language": "AR",
        "text": "تابع ل"
      },
      {
        "language": "FR",
        "text": "Rapporter ŕ"
      }
    ]
  },
  {
    "key": "btn_cancel",
    "text": "Cancel",
    "translations": [
      {
        "language": "AR",
        "text": "إلغاء"
      },
      {
        "language": "FR",
        "text": "Annuler "
      }
    ]
  },
  {
    "key": "txtExportReport",
    "text": "Download Report",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل التقرير"
      },
      {
        "language": "FR",
        "text": "Rapport de Téléchargement"
      }
    ]
  },
  {
    "key": "txtSpecifyHere",
    "text": "Specify here...",
    "translations": [
      {
        "language": "AR",
        "text": "وضح هنا..."
      },
      {
        "language": "FR",
        "text": "Précisez ici ..."
      }
    ]
  },
  {
    "key": "txtQ",
    "text": "Q",
    "translations": [
      {
        "language": "AR",
        "text": "س"
      },
      {
        "language": "FR",
        "text": "Q"
      }
    ]
  },
  {
    "key": "txtMostLiked",
    "text": "Most Liked...",
    "translations": [
      {
        "language": "AR",
        "text": "الأكثر تفضيلاً"
      },
      {
        "language": "FR",
        "text": "Le Plus Préféré..."
      }
    ]
  },
  {
    "key": "txtLeastLiked",
    "text": "Least Liked...",
    "translations": [
      {
        "language": "AR",
        "text": "الأقل تفضيلاً"
      },
      {
        "language": "FR",
        "text": "Le Moins Préféré..."
      }
    ]
  },
  {
    "key": "btn_back",
    "text": "Back",
    "translations": [
      {
        "language": "AR",
        "text": "عودة"
      },
      {
        "language": "FR",
        "text": "Retour"
      },
      {
        "language": "BN",
        "text": "পূর্ববর্তী"
      }
    ]
  },
  {
    "key": "txtSAnswers",
    "text": "'s Answers",
    "translations": [
      {
        "language": "AR",
        "text": "أجوبة "
      },
      {
        "language": "FR",
        "text": "Réponses de"
      }
    ]
  },
  {
    "key": "txtjoinersAnswers",
    "text": "Joiner Answers",
    "translations": [
      {
        "language": "AR",
        "text": "أجوبة الموظف الجديد"
      }
    ]
  },
  {
    "key": "txt_joiner_employee_ID",
    "text": "Joiner ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID du Sortant"
      }
    ]
  },
  {
    "key": "txt_joiner_employee_name",
    "text": "Joiner's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الموظف"
      },
      {
        "language": "FR",
        "text": "Nom du Sortant"
      }
    ]
  },
  {
    "key": "txt_joiner_email",
    "text": "Email",
    "translations": [
      {
        "language": "AR",
        "text": "البريد الإلكتروني"
      },
      {
        "language": "FR",
        "text": "Email (Courrier électronique)"
      },
      {
        "language": "BN",
        "text": "ইমেইল"
      }
    ]
  },
  {
    "key": "txt_country_code",
    "text": "Country Code",
    "translations": [
      {
        "language": "AR",
        "text": "رمز الدولة"
      },
      {
        "language": "FR",
        "text": "Code postal"
      }
    ]
  },
  {
    "key": "Next Step",
    "text": "Next Step",
    "translations": [
      {
        "language": "AR",
        "text": "الخطوة التالية"
      }
    ]
  },
  {
    "key": "txt_dashboard_export",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      }
    ]
  },
  {
    "key": "txt_country_code",
    "text": "Country Code",
    "translations": [
      {
        "language": "AR",
        "text": "رمز الدولة"
      },
      {
        "language": "FR",
        "text": "Code postal"
      }
    ]
  },
  {
    "key": "txt_updated_success",
    "text": "Updated Successfully!",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث بنجاح!"
      },
      {
        "language": "FR",
        "text": "Mise ŕ jour avec Succčs!"
      }
    ]
  },
  {
    "key": "txt_okay_action",
    "text": "Okay",
    "translations": [
      {
        "language": "AR",
        "text": "حسناً"
      },
      {
        "language": "FR",
        "text": "D'accord"
      }
    ]
  },
  {
    "key": "txt_unit_deduction",
    "text": "#UNITS# units will be deducted for this action",
    "translations": [
      {
        "language": "AR",
        "text": "#UNITS# وحدة سيتم خصمها لعمل هذا الاستبيان"
      },
      {
        "language": "FR",
        "text": "#UNITS# les unités seront déduites pour cette action"
      }
    ]
  },
  {
    "key": "Set due date on",
    "text": "Set due date on",
    "translations": [
      {
        "language": "AR",
        "text": "عيِِن تاريخ الاتمام في"
      }
    ]
  },
  {
    "key": "txt_joiner_mobile_number",
    "text": "Mobile Number",
    "translations": [
      {
        "language": "AR",
        "text": "رقم الهاتف المحمول"
      },
      {
        "language": "FR",
        "text": "Numéro de Portable"
      }
    ]
  },
  {
    "key": "txt_joiner_date_of_birth",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الميلاد"
      },
      {
        "language": "FR",
        "text": "Date de Naissance "
      },
      {
        "language": "BN",
        "text": "জন্ম তারিখ"
      }
    ]
  },
  {
    "key": "txt_joiner_gender",
    "text": "Gender",
    "translations": [
      {
        "language": "AR",
        "text": "الجنس"
      },
      {
        "language": "FR",
        "text": "Sexe "
      },
      {
        "language": "HI",
        "text": "लिंग"
      },
      {
        "language": "TA",
        "text": "Kasarian"
      },
      {
        "language": "UR",
        "text": "جنس"
      },
      {
        "language": "BN",
        "text": "লিঙ্গ"
      }
    ]
  },
  {
    "key": "txt_joiner_nationality",
    "text": "Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "الجنسية"
      },
      {
        "language": "FR",
        "text": "Nationalité"
      },
      {
        "language": "HI",
        "text": "राष्ट्रीयता"
      },
      {
        "language": "TA",
        "text": "Nasyonalidad"
      },
      {
        "language": "UR",
        "text": "قومیت"
      },
      {
        "language": "BN",
        "text": "জাতীয়তা"
      }
    ]
  },
  {
    "key": "txt_entity_group_name",
    "text": "New Entity",
    "translations": [
      {
        "language": "AR",
        "text": "وحدة"
      },
      {
        "language": "FR",
        "text": "Unité"
      }
    ]
  },
  {
    "key": "btn_add_structure_entity",
    "text": "Add Entity",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة وحدة"
      },
      {
        "language": "FR",
        "text": "Ajouter une Entité"
      }
    ]
  },
  {
    "key": "txt_entity_name",
    "text": "Entity Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم الوحدة"
      },
      {
        "language": "FR",
        "text": "Nom de l’Unité"
      }
    ]
  },
  {
    "key": "btn_update",
    "text": "Update",
    "translations": [
      {
        "language": "AR",
        "text": "تحديث"
      },
      {
        "language": "FR",
        "text": "Mettre ŕ jour"
      }
    ]
  },
  {
    "key": "txt_group_name",
    "text": "Entity Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الوحدة"
      },
      {
        "language": "FR",
        "text": "Type d’Unité"
      }
    ]
  },
  {
    "key": "txt_define_entities_reports",
    "text": "Define Entities belonging to ",
    "translations": [
      {
        "language": "AR",
        "text": "عرّف الوحدات التي تنتمي إلى"
      },
      {
        "language": "FR",
        "text": "Définir les entités appartenant ŕ "
      }
    ]
  },
  {
    "key": "txt_parent_entity_group",
    "text": "Parent Entity",
    "translations": [
      {
        "language": "AR",
        "text": "الوحدة الأم"
      },
      {
        "language": "FR",
        "text": "Société mčre"
      }
    ]
  },
  {
    "key": "txt_joiner_job_title",
    "text": "Job Title",
    "translations": [
      {
        "language": "AR",
        "text": "المسمى الوظيفي"
      },
      {
        "language": "FR",
        "text": "Titre d'Emploi"
      }
    ]
  },
  {
    "key": "txt_joiner_direct_manager_name",
    "text": "Direct Manager's Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم المدير المباشر"
      },
      {
        "language": "FR",
        "text": "Nom du Directeur Directe"
      }
    ]
  },
  {
    "key": "txt_joiner_job_level",
    "text": "Band Level",
    "translations": [
      {
        "language": "AR",
        "text": "المستوى الوظيفي"
      },
      {
        "language": "FR",
        "text": "Niveau d'Emploi"
      }
    ]
  },
  {
    "key": "txt_joiner_job_grade",
    "text": "Job Grade",
    "translations": [
      {
        "language": "AR",
        "text": "الدرجة الوظيفية"
      },
      {
        "language": "FR",
        "text": "Catégorie d'Emploi"
      }
    ]
  },
  {
    "key": "txt_joiner_performance_rate",
    "text": "Performance Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل تقييم الأداء"
      },
      {
        "language": "FR",
        "text": "Taux de Performance"
      }
    ]
  },
  {
    "key": "txt_joiner_seperation_type",
    "text": "Separation Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الفصل"
      },
      {
        "language": "FR",
        "text": "Type de Séparation"
      }
    ]
  },
  {
    "key": "txtPoweredby",
    "text": "Powered by:",
    "translations": [
      {
        "language": "AR",
        "text": "مشغّل بواسطة"
      },
      {
        "language": "FR",
        "text": "Alimenté par:"
      },
      {
        "language": "BN",
        "text": "দ্বারা চালিত:"
      }
    ]
  },
  {
    "key": "txt_joiner_seperation_types",
    "text": "Separation Types",
    "translations": [
      {
        "language": "AR",
        "text": "أنواع الفصل"
      }
    ]
  },
  {
    "key": "txt_joiner_seperation_date",
    "text": "Seperation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الفصل"
      },
      {
        "language": "FR",
        "text": "Date de Séparation d’emploi"
      }
    ]
  },
  {
    "key": "txt_joiner_end_date",
    "text": "Survey Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء من الاستبيان"
      },
      {
        "language": "FR",
        "text": "Date d’Achčvement du Enquęte"
      }
    ]
  },
  {
    "key": "txt_direct_manager_ID",
    "text": "Direct Manager ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي للمدير المباشر"
      },
      {
        "language": "FR",
        "text": "ID du Directeur Direct"
      }
    ]
  },
  {
    "key": "txtOverallResponseRate",
    "text": "Overall Response Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل الاستجابة العام"
      },
      {
        "language": "FR",
        "text": "Taux de Réponse Global"
      }
    ]
  },
  {
    "key": "txtRespbygender",
    "text": "Respondents by Gender",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنس"
      },
      {
        "language": "FR",
        "text": "Répondants par Sexe"
      }
    ]
  },
  {
    "key": "txtRespby",
    "text": "Respondents by ",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب "
      }
    ]
  },
  {
    "key": "txtRespbynationality",
    "text": "Respondents by Nationality",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الجنسية"
      },
      {
        "language": "FR",
        "text": "Répondants par Nationalité"
      }
    ]
  },
  {
    "key": "txtRespBySepType",
    "text": "Respondents by Seperation Type",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب نوع الفصل"
      }
    ]
  },
  {
    "key": "txtUseSpreadsheet",
    "text": "Use a spreadsheet",
    "translations": [
      {
        "language": "AR",
        "text": "استعمل جدول"
      }
    ]
  },
  {
    "key": "txtAddNewjoinerText",
    "text": "Please select how you want to add the new joiner:",
    "translations": [
      {
        "language": "AR",
        "text": "اختر كيفية إضافة الموظف الجديد:"
      }
    ]
  },
  {
    "key": "txtID",
    "text": "ID",
    "translations": [
      {
        "language": "AR",
        "text": "الرقم الوظيفي"
      },
      {
        "language": "FR",
        "text": "ID"
      }
    ]
  },
  {
    "key": "txtSeperationType",
    "text": "Seperation Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الفصل"
      },
      {
        "language": "FR",
        "text": "Type de Séparation"
      }
    ]
  },
  {
    "key": "btn_add_manually",
    "text": "Add Manually",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة يدوية"
      },
      {
        "language": "FR",
        "text": "Ajouter Manuellement"
      }
    ]
  },
  {
    "key": "txt_date_of_birth",
    "text": "Date of Birth",
    "translations": [
      {
        "language": "AR",
        "text": "تاريح الميلاد"
      },
      {
        "language": "FR",
        "text": "Date de Naissance "
      },
      {
        "language": "BN",
        "text": "জন্ম তারিখ"
      }
    ]
  },
  {
    "key": "btn_previous",
    "text": "Previous",
    "translations": [
      {
        "language": "AR",
        "text": "السابق"
      },
      {
        "language": "FR",
        "text": "Précédent"
      }
    ]
  },
  {
    "key": "txtPerformance",
    "text": "Performance",
    "translations": [
      {
        "language": "AR",
        "text": "الأداء"
      },
      {
        "language": "FR",
        "text": "Performance"
      },
      {
        "language": "BN",
        "text": "কর্মক্ষমতা"
      }
    ]
  },
  {
    "key": "txt_survey",
    "text": "Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان"
      },
      {
        "language": "FR",
        "text": "Enquęte"
      }
    ]
  },
  {
    "key": "txt_survey_questions",
    "text": "Survey Questions",
    "translations": [
      {
        "language": "AR",
        "text": "أسئلة الاستبيان"
      },
      {
        "language": "BN",
        "text": "সমীক্ষা প্রশ্ন"
      }
    ]
  },
  {
    "key": "txtColumnName",
    "text": "Column Name",
    "translations": [
      {
        "language": "AR",
        "text": "اسم العمود"
      }
    ]
  },
  {
    "key": "txt_notStartedYet",
    "text": "Not Started Yet",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم البدء بالعمل عليه بعد"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      },
      {
        "language": "FR",
        "text": "Aperçu "
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      },
      {
        "language": "FR",
        "text": "introduction"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use the Report",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من التقرير؟"
      },
      {
        "language": "FR",
        "text": "Comment Utiliser le Rapport  "
      }
    ]
  },
  {
    "key": "txt_scheduled",
    "text": "Scheduled",
    "translations": [
      {
        "language": "AR",
        "text": "مُجَدوَل"
      }
    ]
  },
  {
    "key": "txt_status",
    "text": "Status",
    "translations": [
      {
        "language": "AR",
        "text": "الحالة"
      },
      {
        "language": "FR",
        "text": "Statut "
      }
    ]
  },
  {
    "key": "txt_dashboard",
    "text": "Dashboard",
    "translations": [
      {
        "language": "AR",
        "text": "صفحة البيانات"
      },
      {
        "language": "FR",
        "text": "Tableau des Données "
      }
    ]
  },
  {
    "key": "txt_completed",
    "text": "Completed",
    "translations": [
      {
        "language": "AR",
        "text": "مكتمل"
      },
      {
        "language": "FR",
        "text": "Complet"
      }
    ]
  },
  {
    "key": "txt_expired",
    "text": "Expired",
    "translations": [
      {
        "language": "AR",
        "text": "منتهي الصلاحية"
      },
      {
        "language": "FR",
        "text": "Expiré"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaires"
      }
    ]
  },
  {
    "key": "txtComment",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaire"
      }
    ]
  },
  {
    "key": "txtComments2",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "تعليقات"
      }
    ]
  },
  {
    "key": "txtDefinitions",
    "text": "Definitions",
    "translations": [
      {
        "language": "AR",
        "text": "التعريفات"
      }
    ]
  },
  {
    "key": "Selected Different Industries",
    "text": "Selected Different Industries",
    "translations": [
      {
        "language": "AR",
        "text": "القطاعات المختلفة المختارة"
      }
    ]
  },
  {
    "key": "Driver / Question",
    "text": "Factor / Statement",
    "translations": [
      {
        "language": "AR",
        "text": "عامل / عبارة"
      }
    ]
  },
  {
    "key": "joiners By Seperation Type",
    "text": "joiners By Seperation Type",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفون المغادرون حسب نوع الفصل"
      }
    ]
  },
  {
    "key": "txtJoinersAnalysis",
    "text": "Joiners' Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات الموظفين الجدد"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Statements",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": "Questions"
      },
      {
        "language": "BN",
        "text": "টি প্রশ্ন"
      }
    ]
  },
  {
    "key": "txtComments",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Commentaires"
      }
    ]
  },
  {
    "key": "txtEmployeeSatisfactionRate",
    "text": "Employee Satisfaction Rate",
    "translations": [
      {
        "language": "AR",
        "text": "معدل رضا الموظفين"
      }
    ]
  },
  {
    "key": "txtEXTREMELYUNSATISFIED",
    "text": "EXTREMELY UNSATISFIED",
    "translations": [
      {
        "language": "AR",
        "text": "غير راضٍ إطلاقاً"
      }
    ]
  },
  {
    "key": "txtUNSATISFIED",
    "text": "UNSATISFIED",
    "translations": [
      {
        "language": "AR",
        "text": "غير راضٍ"
      }
    ]
  },
  {
    "key": "txtNeutral",
    "text": "NEUTRAL",
    "translations": [
      {
        "language": "AR",
        "text": "معتدل"
      },
      {
        "language": "FR",
        "text": "Modéré"
      }
    ]
  },
  {
    "key": "txtPromoters",
    "text": "Promoters",
    "translations": [
      {
        "language": "AR",
        "text": "المروجون"
      }
    ]
  },
  {
    "key": "txtPassives",
    "text": "Passives",
    "translations": [
      {
        "language": "AR",
        "text": "السلبيون (الغير مروجين)"
      }
    ]
  },
  {
    "key": "txtPromotersDef",
    "text": "the employees who select a score of 9 or 10; are positive, motivated, and satisfied people.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 9 إلى 10 وهم المروجون والموظفون الأوفياء."
      }
    ]
  },
  {
    "key": "txtPassivesDef",
    "text": "the employees who select a score of 7 or 8; are neutral, maybe content, or even not fully dedicated to the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 7 إلى 8 لأنهم معجبون بالعمل أو الشركة ولكنهم غير راضين بشكل كافٍ للتوصية بها للآخرين."
      }
    ]
  },
  {
    "key": "txtTenure",
    "text": "Tenure",
    "translations": [
      {
        "language": "AR",
        "text": "سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txt_search",
    "text": "Search",
    "translations": [
      {
        "language": "AR",
        "text": "بحث"
      },
      {
        "language": "FR",
        "text": "Rechercher"
      }
    ]
  },
  {
    "key": "txt_start_date",
    "text": "Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البدء"
      },
      {
        "language": "FR",
        "text": "Date de Début "
      }
    ]
  },
  {
    "key": "txt_end_date",
    "text": "End Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء"
      },
      {
        "language": "FR",
        "text": "Date de Fin"
      }
    ]
  },
  {
    "key": "txtNA",
    "text": "N/A",
    "translations": [
      {
        "language": "AR",
        "text": "لا ينطبق"
      },
      {
        "language": "FR",
        "text": "N/A"
      }
    ]
  },
  {
    "key": "txtStronglyDisagree",
    "text": "Strongly Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "لا أوافق بشدة"
      },
      {
        "language": "FR",
        "text": "Fortement en désaccord"
      }
    ]
  },
  {
    "key": "txtDisagree",
    "text": "Disagree",
    "translations": [
      {
        "language": "AR",
        "text": "لا أوافق"
      },
      {
        "language": "FR",
        "text": "Désaccord"
      }
    ]
  },
  {
    "key": "txtAgree",
    "text": "Agree",
    "translations": [
      {
        "language": "AR",
        "text": "أوافق"
      },
      {
        "language": "FR",
        "text": "Accepter "
      }
    ]
  },
  {
    "key": "btn_joiner_list_view_answers",
    "text": "View Answers",
    "translations": [
      {
        "language": "AR",
        "text": "تصفح الأجوبة"
      },
      {
        "language": "FR",
        "text": "Voir les Réponses"
      }
    ]
  },
  {
    "key": "txtMean",
    "text": "Mean",
    "translations": [
      {
        "language": "AR",
        "text": "المتوسط"
      },
      {
        "language": "FR",
        "text": "Moyenne"
      }
    ]
  },
  {
    "key": "txtStronglyAgree",
    "text": "Strongly Agree",
    "translations": [
      {
        "language": "AR",
        "text": "أوافق بشدة"
      },
      {
        "language": "FR",
        "text": "Tout ŕ fait d'accord"
      }
    ]
  },
  {
    "key": "txt_joiner_joining_date",
    "text": "Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام للعمل"
      },
      {
        "language": "FR",
        "text": "Date d'Inscription"
      },
      {
        "language": "HI",
        "text": "कार्यग्रहण तिथि"
      },
      {
        "language": "TA",
        "text": "Petsa ng Pagsali"
      },
      {
        "language": "UR",
        "text": "شامل ہونے کی تاریخ"
      },
      {
        "language": "BN",
        "text": "যোগদানের তারিখ"
      }
    ]
  },
  {
    "key": "txt_joiner_seperation_date",
    "text": "Seperation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الفصل"
      },
      {
        "language": "FR",
        "text": "Date de Séparation d’emploi"
      }
    ]
  },
  {
    "key": "txt_joiner_start_date",
    "text": "Survey Start Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ بدء الاستبيان"
      },
      {
        "language": "FR",
        "text": "Date de Début de Enquęte "
      }
    ]
  },
  {
    "key": "txt_joiner_end_date",
    "text": "Survey Completion Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانتهاء من الاستبيان"
      },
      {
        "language": "FR",
        "text": "Date d’Achčvement du Enquęte"
      }
    ]
  },
  {
    "key": "txt_joiner_personal_info",
    "text": "Personal Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الشخصية للموظف المغادر"
      },
      {
        "language": "FR",
        "text": "Informations Personnelles du Sortant"
      }
    ]
  },
  {
    "key": "txt_joiner_positional_info",
    "text": "Positional Information",
    "translations": [
      {
        "language": "AR",
        "text": "المعلومات الوظيفية للموظف المغادر"
      },
      {
        "language": "FR",
        "text": "Informations sur la Position du Sortant"
      }
    ]
  },
  {
    "key": "txt_joiner_time_frame",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Délai"
      }
    ]
  },
  {
    "key": "txt_time_frame_start",
    "text": "Time Frame Start",
    "translations": [
      {
        "language": "AR",
        "text": "بداية المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_new_joiner",
    "text": "New joiner",
    "translations": [
      {
        "language": "AR",
        "text": " إضافة موظف جديد "
      },
      {
        "language": "FR",
        "text": "Nouveau Sortant"
      }
    ]
  },
  {
    "key": "txt_edit_joiner",
    "text": "Edit joiner",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الموظف الجديد"
      },
      {
        "language": "FR",
        "text": "Modifier le Sortant"
      }
    ]
  },
  {
    "key": "txt_time_frame_end",
    "text": "Time Frame End",
    "translations": [
      {
        "language": "AR",
        "text": "نهاية المدة الزمنية"
      }
    ]
  },
  {
    "key": "txt_invitation_date",
    "text": "Invitation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الإرسال"
      },
      {
        "language": "FR",
        "text": "Date d'invitation"
      }
    ]
  },
  {
    "key": "txtCustomizeTable",
    "text": "Customize Table",
    "translations": [
      {
        "language": "AR",
        "text": "عدِِل الجدول"
      }
    ]
  },
  {
    "key": "txtCustomize",
    "text": "Customize",
    "translations": [
      {
        "language": "AR",
        "text": "عدِِل"
      }
    ]
  },
  {
    "key": "Finish",
    "text": "Finish",
    "translations": [
      {
        "language": "AR",
        "text": "انهِ"
      }
    ]
  },
  {
    "key": "Joining Date",
    "text": "Joining Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الانضمام"
      },
      {
        "language": "HI",
        "text": "कार्यग्रहण तिथि"
      },
      {
        "language": "TA",
        "text": "Petsa ng Pagsali"
      },
      {
        "language": "UR",
        "text": "شامل ہونے کی تاریخ"
      }
    ]
  },
  {
    "key": "Start date",
    "text": "Start date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ البداية"
      }
    ]
  },
  {
    "key": "Due Date",
    "text": "Due Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الاتمام"
      }
    ]
  },
  {
    "key": "Send invitation on",
    "text": "Send invitation on",
    "translations": [
      {
        "language": "AR",
        "text": "ارسل الدعوة في تاريخ"
      }
    ]
  },
  {
    "key": "Separation Date",
    "text": "Separation Date",
    "translations": [
      {
        "language": "AR",
        "text": "تاريخ الفصل"
      }
    ]
  },
  {
    "key": "btnExport",
    "text": "Download",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      },
      {
        "language": "FR",
        "text": "Télécharger"
      }
    ]
  },
  {
    "key": "txtDetractors",
    "text": "Detractors",
    "translations": [
      {
        "language": "AR",
        "text": "المنتقدون"
      }
    ]
  },
  {
    "key": "txtDetractorsDef",
    "text": "the employees who select a score between 0 – 6 are unhappy and disengaged employees who won't recommend your business as a good workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "هم الذين أجابوا السؤال من 0 إلى 6 لأنهم غير راضين عن العمل أو الشركة."
      }
    ]
  },
  {
    "key": "txtENPS",
    "text": "Employee Net Promoter Score (eNPS)",
    "translations": [
      {
        "language": "AR",
        "text": "صافي نقاط ترويج الموظفين (eNPS)"
      }
    ]
  },
  {
    "key": "txtENPSDesc",
    "text": "eNPS measures employee loyalty by identifying them as promoters, passives, and detractors of your brand.",
    "translations": [
      {
        "language": "AR",
        "text": "eNPS يقيس ولاء الموظفين من خلال تحديدهم كمروجين أو سلبيين (غير مروجين) أو منتقدين لعلامتك التجارية."
      }
    ]
  },
  {
    "key": "txtSATISFIED",
    "text": "SATISFIED",
    "translations": [
      {
        "language": "AR",
        "text": "راضٍ"
      }
    ]
  },
  {
    "key": "txtEXTREMELYSATISFIED",
    "text": "EXTREMELY SATISFIED",
    "translations": [
      {
        "language": "AR",
        "text": "راضٍ بشدة"
      }
    ]
  },
  {
    "key": "txtSurveyStatus",
    "text": "Survey Status",
    "translations": [
      {
        "language": "AR",
        "text": "حالة الاستبيان"
      },
      {
        "language": "FR",
        "text": "Statut de Enquęte "
      }
    ]
  },
  {
    "key": "txtSeperationType",
    "text": "Seperation Type",
    "translations": [
      {
        "language": "AR",
        "text": "نوع الفصل"
      },
      {
        "language": "FR",
        "text": "Type de Séparation"
      }
    ]
  },
  {
    "key": "txtPercentageOfjoiners",
    "text": "Percentage of joiners",
    "translations": [
      {
        "language": "AR",
        "text": "نسبة المغادرين"
      },
      {
        "language": "FR",
        "text": "Pourcentage de sortants"
      }
    ]
  },
  {
    "key": "txt_activejoinerslist_export",
    "text": "Active joiners List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين الفعالة"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants Actifs"
      }
    ]
  },
  {
    "key": "txt_joiner_action_updated",
    "text": "updated",
    "translations": [
      {
        "language": "AR",
        "text": "تم التحديث"
      },
      {
        "language": "FR",
        "text": "Mis ŕ jour"
      }
    ]
  },
  {
    "key": "txt_joiner_creation_today_no_email",
    "text": "joiner #ACTION#, an email has been sent to you for your reference or you can share the link below",
    "translations": [
      {
        "language": "AR",
        "text": "joiner #ACTION#, an email has been sent to you for your reference or you can share the link below"
      },
      {
        "language": "FR",
        "text": "Sortant #ACTION#, un email vous a été envoyé pour votre référence ou vous pouvez partager le lien ci-dessous"
      }
    ]
  },
  {
    "key": "txt_joiner_creation_not_today_email",
    "text": "joiner #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #joinerEMAIL# on #STARTDATE# or you can share the link below",
    "translations": [
      {
        "language": "AR",
        "text": "joiner #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to #joinerEMAIL# on #STARTDATE# or you can share the link below"
      },
      {
        "language": "FR",
        "text": "Sortant #ACTION#, un email vous a été envoyé pour votre référence Un email sera automatiquement envoyé à #joinerEMAIL# le #STARTDATE# ou vous pouvez partager le lien ci-dessous"
      }
    ]
  },
  {
    "key": "txt_joiner_creation_not_today_no_email",
    "text": "joiner #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below",
    "translations": [
      {
        "language": "AR",
        "text": "joiner #ACTION#, an email has been sent to you for your reference. An email will be automatically be sent to you on #STARTDATE# or you can share the link below"
      },
      {
        "language": "FR",
        "text": "Sortant #ACTION#, un email vous a été envoyé pour votre référence Un email vous sera automatiquement envoyé le #STARTDATE# ou vous pouvez partager le lien ci-dessous"
      }
    ]
  },
  {
    "key": "txt_delete_joiner",
    "text": "Are you sure you want to set this joiner to Inactive?",
    "translations": [
      {
        "language": "AR",
        "text": "هل أنت متأكد أنك تريد تغيير حالة الموظف المغادر لغير فعال؟"
      },
      {
        "language": "FR",
        "text": "Ętes-vous sűr de vouloir mettre ce sortant ŕ Inactif ?"
      }
    ]
  },
  {
    "key": "txt_yes",
    "text": "Yes",
    "translations": [
      {
        "language": "AR",
        "text": "نعم"
      },
      {
        "language": "FR",
        "text": "Oui"
      }
    ]
  },
  {
    "key": "txt_PENDING",
    "text": "Not Started",
    "translations": [
      {
        "language": "AR",
        "text": "لم يتم تعبئة الاستبيان"
      },
      {
        "language": "FR",
        "text": "En attente"
      }
    ]
  },
  {
    "key": "btn_joiner_list_edit",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      },
      {
        "language": "FR",
        "text": "Modifier"
      }
    ]
  },
  {
    "key": "JoinerDetails",
    "text": "Joiner Details",
    "translations": [
      {
        "language": "AR",
        "text": "بيانات الموظف الجديد"
      }
    ]
  },
  {
    "key": "Personal",
    "text": "Personal",
    "translations": [
      {
        "language": "AR",
        "text": "شخصي"
      }
    ]
  },
  {
    "key": "Position",
    "text": "Position",
    "translations": [
      {
        "language": "AR",
        "text": "الوظيفة"
      }
    ]
  },
  {
    "key": "Positional",
    "text": "Positional",
    "translations": [
      {
        "language": "AR",
        "text": "وظيفي"
      }
    ]
  },
  {
    "key": "txt_total_questionnaires",
    "text": "Total Surveys",
    "translations": [
      {
        "language": "AR",
        "text": "مجموع الاستبيانات"
      },
      {
        "language": "FR",
        "text": "Enquętes Totales"
      }
    ]
  },
  {
    "key": "txt_inactivejoinerslist_export",
    "text": "InActive joiners List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين غير الفعالة"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants Inactifs"
      }
    ]
  },
  {
    "key": "Inactive",
    "text": "Inactive",
    "translations": [
      {
        "language": "AR",
        "text": "غير فعال"
      }
    ]
  },
  {
    "key": "txtSection",
    "text": "Section",
    "translations": [
      {
        "language": "AR",
        "text": "قسم"
      },
      {
        "language": "FR",
        "text": "Section"
      }
    ]
  },
  {
    "key": "txt_expiredjoinerslist_export",
    "text": "Expired joiners List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة الموظفين المغادرين المنتهية صلاحيتها"
      },
      {
        "language": "FR",
        "text": "Liste des Sortants Expirés"
      }
    ]
  },
  {
    "key": "txtNoOfjoiners",
    "text": "Number of joiners",
    "translations": [
      {
        "language": "AR",
        "text": "عدد المغادرين"
      },
      {
        "language": "FR",
        "text": "Nombre des Partants"
      }
    ]
  },
  {
    "key": "txt_Onboarding_Questionnaire",
    "text": "Employee Onboarding Survey",
    "translations": [
      {
        "language": "AR",
        "text": "استبيان خروج الموظف وإنتهاء العمل"
      },
      {
        "language": "FR",
        "text": "Enquęte sur les sorties des employés"
      }
    ]
  },
  {
    "key": "txtDistribution",
    "text": "Distribution",
    "translations": [
      {
        "language": "AR",
        "text": "توزيع الإجابات"
      },
      {
        "language": "FR",
        "text": "Distribution"
      }
    ]
  },
  {
    "key": "txt_question",
    "text": "Statement",
    "translations": [
      {
        "language": "AR",
        "text": "العبارة"
      },
      {
        "language": "FR",
        "text": "Question"
      },
      {
        "language": "BN",
        "text": "প্রশ্ন"
      }
    ]
  },
  {
    "key": "txt_questions",
    "text": "Questions",
    "translations": [
      {
        "language": "AR",
        "text": "العبارات"
      },
      {
        "language": "FR",
        "text": "Questions"
      },
      {
        "language": "BN",
        "text": "টি প্রশ্ন"
      }
    ]
  },
  {
    "key": "txtOverview",
    "text": "Overview",
    "translations": [
      {
        "language": "AR",
        "text": "نظرة عامة"
      },
      {
        "language": "FR",
        "text": "Aperçu "
      }
    ]
  },
  {
    "key": "txt_joiners",
    "text": "joiners",
    "translations": [
      {
        "language": "AR",
        "text": "الموظفين المغادرين"
      },
      {
        "language": "FR",
        "text": "Sortants"
      }
    ]
  },
  {
    "key": "txt_deleted",
    "text": "Deleted",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذفه"
      },
      {
        "language": "FR",
        "text": "Supprimé"
      }
    ]
  },
  {
    "key": "txt_send_reminder",
    "text": "Send Reminder",
    "translations": [
      {
        "language": "AR",
        "text": "أرسل تذكير"
      },
      {
        "language": "FR",
        "text": "Envoyer un Rappel"
      }
    ]
  },
  {
    "key": "txt_in_progress",
    "text": "In Progress",
    "translations": [
      {
        "language": "AR",
        "text": "قيد الإنجاز"
      },
      {
        "language": "FR",
        "text": "En Progression"
      }
    ]
  },
  {
    "key": "txtNoReportsYet",
    "text": "No joiners to generate reports yet!",
    "translations": [
      {
        "language": "AR",
        "text": "لا يمكن إنشاء تقارير لعدم وجود مغادرين!"
      },
      {
        "language": "FR",
        "text": "Aucun sortant pour générer des rapports pour le moment!"
      }
    ]
  },
  {
    "key": "btn_add_new_joiner",
    "text": "Add joiner",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة موظف جديد"
      },
      {
        "language": "FR",
        "text": "Ajouter Un Sortant"
      }
    ]
  },
  {
    "key": "txt_resp_by_generation",
    "text": "Respondents by Generation",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب نوع الجيل"
      }
    ]
  },
  {
    "key": "txt_resp_by_age_group",
    "text": "Age Group",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب الفئات العمرية"
      }
    ]
  },
  {
    "key": "txt_resp_by_tenure_group",
    "text": "Respondents by Tenure Group",
    "translations": [
      {
        "language": "AR",
        "text": "المستجيبون حسب فئات سنوات الخدمة"
      }
    ]
  },
  {
    "key": "txt_reports",
    "text": "Reports",
    "translations": [
      {
        "language": "AR",
        "text": "التقارير"
      },
      {
        "language": "FR",
        "text": "Rapports"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      },
      {
        "language": "FR",
        "text": "Rapport"
      }
    ]
  },
  {
    "key": "txt_timeframe",
    "text": "Timeframe",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      },
      {
        "language": "FR",
        "text": "Délai"
      }
    ]
  },
  {
    "key": "txt_report",
    "text": "Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير"
      },
      {
        "language": "FR",
        "text": "Rapport"
      }
    ]
  },
  {
    "key": "txtConfidential",
    "text": "Confidential",
    "translations": [
      {
        "language": "AR",
        "text": "خاص وسري"
      },
      {
        "language": "FR",
        "text": "Confidentiel"
      }
    ]
  },
  {
    "key": "txtEmployeeOnboardingAnalysis",
    "text": "Employee Onboarding",
    "translations": [
      {
        "language": "AR",
        "text": "إعداد وتهيئة الموظفين"
      },
      {
        "language": "FR",
        "text": "Sortie de l'employé"
      }
    ]
  },
  {
    "key": "txtEmployeeOnboardingAnalysisReport",
    "text": "Employee Onboarding Analysis",
    "translations": [
      {
        "language": "AR",
        "text": "تحليلات إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "txtEmployeeOnboardingReport",
    "text": "Employee Onboarding Report",
    "translations": [
      {
        "language": "AR",
        "text": "تقرير إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "joiner Notes",
    "text": "joiner Notes",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظات الموظف الجديد"
      }
    ]
  },
  {
    "key": "Add Note",
    "text": "Add Note",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ملاحظة"
      }
    ]
  },
  {
    "key": "New Note",
    "text": "New Note",
    "translations": [
      {
        "language": "AR",
        "text": "ملاحظة جديدة"
      }
    ]
  },
  {
    "key": "Name",
    "text": "Name",
    "translations": [
      {
        "language": "AR",
        "text": "الاسم"
      }
    ]
  },
  {
    "key": "A note can't be empty!",
    "text": "A note can't be empty!",
    "translations": [
      {
        "language": "AR",
        "text": "يجب كتابة الملاحظة"
      }
    ]
  },
  {
    "key": "Note added successuflly",
    "text": "Note added successuflly",
    "translations": [
      {
        "language": "AR",
        "text": "تمت إضافة الملاحظة بنجاح"
      }
    ]
  },
  {
    "key": "Note deleted successuflly",
    "text": "Note deleted successuflly",
    "translations": [
      {
        "language": "AR",
        "text": "تم مسح الملاحظة بنجاح"
      }
    ]
  },
  {
    "key": "Leave a note here.",
    "text": "Leave a note here.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف ملاحظة هنا."
      }
    ]
  },
  {
    "key": "Notes",
    "text": "Notes",
    "translations": [
      {
        "language": "AR",
        "text": "الملاحظات"
      }
    ]
  },
  {
    "key": "Note",
    "text": "Note",
    "translations": [
      {
        "language": "AR",
        "text": "الملاحظة"
      }
    ]
  },
  {
    "key": "Delete Note",
    "text": "Delete Note",
    "translations": [
      {
        "language": "AR",
        "text": "مسح الملاحظة"
      }
    ]
  },
  {
    "key": "Edit Note",
    "text": "Edit Note",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل الملاحظة"
      }
    ]
  },
  {
    "key": "txtEmployeeOnboardingFactors",
    "text": "Employee Onboarding Factors",
    "translations": [
      {
        "language": "AR",
        "text": "عوامل إعداد وتهيئة الموظفين"
      }
    ]
  },
  {
    "key": "VPOOREXP",
    "text": "Very Poor Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة سيئة للغاية"
      }
    ]
  },
  {
    "key": "POOREXP",
    "text": "Poor Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة سيئة "
      }
    ]
  },
  {
    "key": "FAIREXP",
    "text": "Fair Experience",
    "translations": [
      {
        "language": "AR",
        "text": "محايد"
      }
    ]
  },
  {
    "key": "GOODEXP",
    "text": "Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جيدة"
      }
    ]
  },
  {
    "key": "VGOODEXP",
    "text": "Very Good Experience",
    "translations": [
      {
        "language": "AR",
        "text": "تجربة جيدة للغاية"
      }
    ]
  },
  {
    "key": "belongingDesc",
    "text": "Belonging is the degree to which a new employee feels welcomed, accepted, and valued by the team and organization. A new employee's knowledge, skills, abilities, and personality must complement the team members for the organization to meet its goals. Team members welcoming the new employees in their early weeks make them feel a sensation of belongingness and acceptance and ease the stress of the onboarding process. \n <br> <br> New employees are more likely to engage when they see two-way communication flowing smoothly throughout the workplace. Hence, effective communication and initiatives to connect with new employees from day one of the onboarding process will likely boost employee morale, job satisfaction, and a sense of community. Good relationships between employees of different job levels and new employees are crucial to create a sense of belonging and loyalty toward the workplace.",
    "translations": [
      {
        "language": "AR",
        "text": "الانتماء هو الحد الذي من خلاله يشعر الموظف الجديد بالترحيب والقبول والتقدير من قبل الفريق والشركة. ويجب أن تكون البنية المعرفية للموظف الجديد ومهاراته وقدراته وشخصيته مكملة لباقي موظفي الشركة من أجل تحقيق أهدافها. ويقوم موظفي الشركة بالترحيب بالموظفين الجدد منذ الأسابيع الأولى من التحاقهم بالشركة بحيث يمنحهم ذلك الإحساس بالانتماء والقبول، ويخفف من الضغوط  المتبعة في عملية الإعداد والتهيئة.\n <br> <br>ومن المرجح أن يتفاعل الموظفون الجدد بفعالية أكبر عند ملاحظة أن التواصل متبادل بينهم وبين موظفي الشركة ويتم بأسلوب سلس في جميع أنحاء مكان العمل، وبالتالي فإن التواصل والمبادرة الفعالة من قبل الشركة للتواصل مع الموظفين الجدد منذ اليوم الأول من عملية الإعداد والتهيئة من شأنها أن تعزز معنويات الموظفين الجدد ومستوى الرضا والاندماج الوظيفي لديهم. وجدير بالذكر أن العلاقات الجيدة فيما بين الموظفين من مختلف المستويات الوظيفية والموظفين الجدد ضرورية لمنحهم الإحساس بالانتماء والولاء تجاه مكان العمل."
      }
    ]
  },
  {
    "key": "txtPreparedFor",
    "text": "Prepared For",
    "translations": [
      {
        "language": "AR",
        "text": "أُعدَّ لـ"
      },
      {
        "language": "FR",
        "text": "Préparé pour"
      }
    ]
  },
  {
    "key": "roleClarityDesc",
    "text": "Role Clarity is the degree to which the new employee understands their role and expectations. Motivating new employees to participate in their job and stay engaged requires clarifying all the necessary job roles & responsibilities and job purposes since their joining date in the workplace. The position assigned to new employees should be aligned with their skills and knowledge to implement a long-lasting successful work relationship. \n <br> <br> Clarifying job roles & responsibilities and workplace goals fosters employees to stay engaged and motivated while having a clear vision of what is expected of them in the workplace. This will ensure the commitment of new employees toward their job responsibilities from the beginning of the onboarding process and hence, prevent employee disengagement due to confusion and lack of certainty.",
    "translations": [
      {
        "language": "AR",
        "text": "وضوح الدور الوظيفي هو الحد الذي من خلاله يتمكن الموظف الجديد  من فهم دوره الوظيفي وما هي توقعاته من ذلك الدور. كما أن تحفيز الموظفين الجدد على الاندماج في وظائفهم واستمرارية مشاركتهم ومساهمتهم يتطلب توضيح جميع الأدوار والمسؤوليات الوظيفية اللازمة منذ تاريخ التحاقهم بمكان العمل. ويجب أن تتماشى الوظائف التي يتم تعيين الموظفين الجدد بها مع مهاراتهم وإمكانياتهم المعرفية لضمان استمرارية علاقة عمل ناجحة على المدى الطويل.\n <br> <br> كما أن توضيح الأدوار والمسؤوليات الوظيفية وأهداف مكان العمل من شأنه أن يحفز الموظفين ويعزز اندماجهم الوظيفي، وذلك مع وجود رؤية واضحة لما هو متوقع منهم في مكان العمل. وسيضمن ذلك التزام الموظفين الجدد بمسؤولياتهم الوظيفية منذ بداية عملية إعدادهم وتهيئتهم للعمل، وبالتالي ضمان عدم مغادرتهم لمكان العمل بسبب عدم وضوح الرؤية لديهم."
      }
    ]
  },
  {
    "key": "adaptabilityDesc",
    "text": "Adaptability is the degree to which the new employee feels enabled to work with the team and organization while satisfying their professional desires. This means they have access to the right information, resources, and data and are well-settled & equipped to perform the job. <br> <br> \n  Adaptability is important to check for compliance and provide administrative support. New employees may need help complying with the organization's policies and procedures. This might include all legal and administrative support related to employment paperwork, badges, email accounts, computers, uniforms, equipment, workstations, and more. Access to information & equipment in the workplace is a major factor in employee success, engagement, motivation, and enhanced performance, all of which contribute to a successful onboarding process.",
    "translations": [
      {
        "language": "AR",
        "text": " القدرة على التكيف هي الحد الذي من خلاله يشعر الموظف الجديد أنه قادر على العمل مع زملائه ومع الشركة بما يتناغم ويتماشى مع رغباته المهنية، وهذا يعني بطبيعة الحال أن لديه حرية الوصول إلى المعلومات والموارد والبيانات الصحيحة، وأنه مستقر ومجهز بما يكفي لأداء مهام وظيفته.<br> <br> \n وجدير بالذكر أن القدرة على التكيف تعتبر من العوامل الضرورية للتحقق من مدى الامتثال لمهام الوظيفة،  وكذلك التحقق من أن الدعم الإداري موفر بشكل فعال. قد يحتاج الموظفون الجدد إلى تقديم المساعدة لهم لتوجيههم في كيفية الامتثال لسياسات وإجراءات الشركة وقد يشمل ذلك ما يلزم من الدعم القانوني والإداري المتعلق بالأوراق الخاصة بالعمل، والشارات، وحسابات البريد الإلكتروني، وأجهزة الحواسيب، والزي الرسمي، والمعدات، ومرافق مكان العمل، وما إلى ذلك. وتعتبر حرية الوصول إلى المعلومات والمعدات في الشركة عاملاً رئيسياً مؤثراً في مدى تحقيق النجاح الذي يصبو إليه الموظفون، وتعزيز اندماجهم الوظيفي، والعمل على تحفيزهم وتحسين مستوى أدائهم، والذي بدوره يساهم في نجاح عملية الإعداد والتهيئة."
      }
    ]
  },
  {
    "key": "continuityDesc",
    "text": "Continuity is the degree to which a new employee is likely to stay and be satisfied with the organization. The workplace should have the capability to motivate new employees to stay by assuring them of a future in their position. Continuity as a factor reveals whether they experienced an excellent or poor onboarding process. A workplace environment that encourages performing challenging tasks and activities to achieve workplace goals makes new employees feel valued, appreciated, and engaged. \n <br> <br> New employees are more likely to stay when they are inspired to perform work, feel valued & recognized, are given exciting & challenging work, and have a work-life balance. ",
    "translations": [
      {
        "language": "AR",
        "text": "الاستمرارية في العمل هي الحد الذي يرجح أن يكون الموظف الجديد من خلاله راضياً عن الشركة وقادراً على الاستمرار بالعمل فيها، ولذلك يجب أن تكون بيئة العمل مهيئة لتحفيز الموظفين الجدد على الاستمرارية بالعمل وذلك من خلال طمأنتهم بمستقبل واعد في مناصبهم الوظيفية لدى الشركة، وجدير بالذكر أن الاستمرارية في العمل باعتباره أحد عوامل الاستقرار الجوهرية يوضح مدى نجاح أو فشل عملية إعداد وتهيئة الموظفين الجدد. وجدير بالذكر أيضاً أن بيئة الشركة التي تحفز موظفيها على القيام بأداء المهام والأنشطة المميزة ذات التحديات لتحقيق أهدافها من شأنها أن تمنح الموظفين الجدد الشعور بالتقييم والتقدير والاندماج في مكان العمل لضمان استمراريتهم في مكان العمل. \n <br> <br> ومن المرجح أن يكون لدى الموظفين الجدد الدافع للاستمرار في مكان العمل عن طريق إلهامهم وتحفيزهم من قبل محيطهم في العمل لأداء مهامهم ومسؤولياتهم، بالإضافة إلى تعزيز شعورهم بالتقدير والتقييم، وتوكيلهم بمهام  تمكنهم من تحدي أنفسهم، وإعطائهم الفرصة لخلق توازن بين حياتهم العملية والاجتماعية."
      }
    ]
  },
  {
    "key": "efficacyDesc",
    "text": "Efficacy is the employee's confidence to perform the job role well. Efficacy stands for self-efficacy and measures if the new employee believes in their own abilities to use, learn, and apply themselves to add value to their team. It helps understand if the onboarding was sufficient and has helped build their confidence. It also helps to understand if the new employee is facing any work stress that needs to be addressed. Self-efficacy of the new employees helps them achieve goals and feel accomplishment. ",
    "translations": [
      {
        "language": "AR",
        "text": "كفاءة الموظف تمثل ثقة الموظف في مدى استطاعة قدراته على أداء دوره الوظيفي بشكل جيد وفعال. ومفهوم كفاءة الموظف يعني الفعالية والكفاءة الذاتية للموظف والتي تقيس مدى ثقة الموظف بقدرته على استخدام، وتعلم، وتطبيق مهاراته وكفاءاته لإضافة قيمة ملموسة إلى فريق عمله، ويساعد ذلك في فهم ما إذا كانت عملية الإعداد والتهيئة كافية و ساعدت في بناء ثقته بنفسه. كما يساعد ذلك أيضاً على فهم ما إذا كان الموظف الجديد يواجه أي ضغوط في العمل بحيث يجب معالجتها، هذا بالإضافة إلى مساعدته على تحقيق الأهداف التي تطمح إليها الشركة وتعزيز شعوره بالإنجاز والتقدم."
      }
    ]
  },
  {
    "key": "txtFactors",
    "text": "Factors",
    "translations": [
      {
        "language": "AR",
        "text": "العوامل"
      }
    ]
  },
  {
    "key": "txtfor",
    "text": "For",
    "translations": [
      {
        "language": "AR",
        "text": "لـ"
      },
      {
        "language": "FR",
        "text": "Pour"
      }
    ]
  },
  {
    "key": "txtEmployeeOnboardingIntroductionpara",
    "text": "<p>Employee Onboarding is the process of helping a new employee settle into a company and its culture through the tools, information, and support needed to become a productive member. The new employee's impression of the organization based on their onboarding experience will likely influence their productivity, job satisfaction, and organizational commitment.<br> <br> \n A poor onboarding experience can lead to employee dissatisfaction, low engagement, poor performance, and high turnover. Hence organizations must strive to make their onboarding experiences as smooth and memorable as possible.<br> <br> \nThe Employee Onboarding Survey applies the BRACE model to measure new employees' overall experience in the workplace. This report displays this through an in-depth analysis, scores, and recommendations..</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p>إن إعداد وتهيئة الموظف هي عملية مساعدة الموظف الجديد على الاستقرار في الشركة والاندماج بأسلوب العمل المتبع بها من خلال توفير ما يلزم من أدوات، ومعلومات، ودعم ليصبح عضواً منتجاً وفعالاً. كما أن انطباع الموظفين الجدد عن الشركة استناداً إلى مدى إعدادهم وتهيئتهم للعمل قد يؤثر على مدى إنتاجيتهم ورضاهم الوظيفي والتزامهم بسياسات الشركة.</p>\n <br>وجدير بالذكر أن سوء إعداد وتهيئة الموظفين قد يؤدي إلى استيائهم من العمل، وانخفاض معدل اندماجهم، وضعف أدائهم، وارتفاع معدل الدوران الوظيفي لدى الشركة. ونتيجة لذلك، يتعين على الشركة أن تسعى جاهدة لتسهيل عملية إعداد وتهيئة الموظف وجعلها تجربة سلسة ترسخ بالذاكرة قدر الإمكان.\n <br> <br> <p>وجدير بالذكر أيضاً أن الاستبيان الخاص بإعداد وتهيئة الموظف يقوم بتطبيق نموذج (BRACE) لغرض قياس الخبرة الإجمالية للموظفين الجدد في مكان العمل. يوضح هذا التقرير كل ما يتعلق بعملية إعداد وتهيئة الموظف من خلال تطبيق تحليل عميق يوضح أهم النتائج المترتبة، وجميع التوصيات المقترحة.</p>"
      }
    ]
  },
  {
    "key": "txtOnboardingCalculationProcess3",
    "text": "eNPS.",
    "translations": [
      {
        "language": "AR",
        "text": "eNPS."
      }
    ]
  },
  {
    "key": "txtOnboardingObjectives",
    "text": "<h4 class=\"text-zen text-xl font-medium pb-7 pt-10\">Objectives of this Report</h4> <div class=\"flex flex-col items-stretch\">   <div class=\"flex flex-col w-full\">     <ul>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>Identify the workplace overall engagement score and understand how lowly, moderately, and highly engaged           employees affect the workplace and its performance.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>Identify strengths through drivers with high engagement and recognize how they impact the workplace.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>Understand areas of improvement through drivers with low engagement and the reason behind the results.</p>       </li>        <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>Access recommended actions to be taken for each driver, whether they are lowly, moderately, or highly           engaged, and how they can be implemented to improve the workplace and environment.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>Obtain open-ended statements or feedback submitted by employees during the survey, use it to improve ways of           doing things, and understand how they feel about the workplace.</p>       </li>     </ul>   </div> </div>",
    "translations": [
      {
        "language": "AR",
        "text": "<h4 class=\"text-zen text-xl font-medium pb-7 pt-10\">أهداف التقرير</h4> <div class=\"flex flex-col items-stretch\">   <div class=\"flex flex-col w-full\">     <ul>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>تحديد درجة الاندماج الإجمالية وفهم كيف يؤثر الموظفون المندمجون بنسبة متدنية، أو معتدلة، أو عالية على مكان           العمل وأدائه.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>تحديد نِقَاط القوة باعتماد عوامل الاندماج ذات الاندماج العالي وإدراك كيفية تأثيرها في مكان العمل.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>تحديد نِقَاط التحسين باعتماد عوامل الاندماج ذات الاندماج المتدني والأسباب وراء هذه النتائج. </p>       </li>        <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>الحصول على توصيات لأخذها بعين الاعتبار لكل عامل اندماج، بغض النظر عن درجة الاندماج الخاصة به إن كانت متدنية،           أو معتدلة، أو عالية وكيفية تطبيق هذه التوصيات لتحسين بيئة ومكان العمل.</p>       </li>       <li class=\"flex flex-row item-stretch pb-3 gap-2\"> <i           class=\"fa-solid text-exp fa-circle text-xxs leading-5\"></i>         <p>الحصول على تعليقات الموظفين من خلال الاستبيان، للاستفادة منها في تطوير طرق تنفيذ الأعمال، وفهم شعور الموظفين           تجاه مكان العمل. </p>       </li>     </ul>   </div> </div>"
      }
    ]
  },
  {
    "key": "txtOnboardingHowtousethisreportpara",
    "text": "<p class=\"mb-4\">Employee Onboarding factors displayed in this report are a result of the new employees' responses.</p>\n <p class=\"mb-4\">Recommended actions in this report are only a few of the many activities that can be taken to improve the workplace environment, and they are not limited to the displayed suggestions.</p>",
    "translations": [
      {
        "language": "AR",
        "text": "<p class=\"mb-4\">إن عوامل إعداد وتهيئة الموظفين المدرجة في هذا التقرير هي نتيجة وخلاصة لاستجابة الموظفين الجدد لهذا الاستبيان.</p>\n <p class=\"mb-4\">كما أن الإجراءات الموصى بها في هذا التقرير ليست سوى جزء لا يتجزأ من الإجراءات العديدة التي يمكن أخذها بعين الاعتبار لغرض تحسين بيئة مكان العمل، وهي بطبيعة الحال لا تقتصر على تلك الإجراءات فحسب.</p>"
      }
    ]
  },
  {
    "key": "txttableofcontents",
    "text": "Table of Contents",
    "translations": [
      {
        "language": "AR",
        "text": "جدول المحتويات"
      },
      {
        "language": "FR",
        "text": "Table des matičres"
      }
    ]
  },
  {
    "key": "txtExportCommentsUnavailable",
    "text": "Comments Unavailable",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات غير متاحة"
      },
      {
        "language": "FR",
        "text": "Commentaires Indisponibles"
      }
    ]
  },
  {
    "key": "txtReminderMissingURL",
    "text": "The reminder is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذا التذكير!"
      },
      {
        "language": "FR",
        "text": "Votre lien a été supprimé dans ce rappel!"
      }
    ]
  },
  {
    "key": "txtInvitationMissingURL",
    "text": "The invitation is missing a link!",
    "translations": [
      {
        "language": "AR",
        "text": "تم حذف الرابط الخاص في هذه الدعوة!"
      },
      {
        "language": "FR",
        "text": "Votre lien a été supprimé dans ce rappel!"
      }
    ]
  },
  {
    "key": "txt_fill_fields",
    "text": "Please, fill all required fields!",
    "translations": [
      {
        "language": "AR",
        "text": "يرجى تعبئة جميع الحقول المطلوبة!"
      }
    ]
  },
  {
    "key": "txtExportCommentCheckbox",
    "text": "Comments",
    "translations": [
      {
        "language": "AR",
        "text": "التعليقات"
      },
      {
        "language": "FR",
        "text": "Télécharger avec commentaires"
      }
    ]
  },
  {
    "key": "txtIntroduction",
    "text": "Introduction",
    "translations": [
      {
        "language": "AR",
        "text": "مقدمة"
      },
      {
        "language": "FR",
        "text": "introduction"
      }
    ]
  },
  {
    "key": "txtHowtousethisreport",
    "text": "How to Use this Report?",
    "translations": [
      {
        "language": "AR",
        "text": "كيف يمكن الاستفادة من هذا التقرير؟"
      },
      {
        "language": "FR",
        "text": "Comment Utiliser le Rapport  "
      }
    ]
  },
  {
    "key": "txtCalculationProcess",
    "text": "Calculation Process",
    "translations": [
      {
        "language": "AR",
        "text": "عملية الحساب"
      },
      {
        "language": "FR",
        "text": "Processus de Calcul"
      }
    ]
  },
  {
    "key": "txtCalculationProcess1",
    "text": "The overall onboarding experience of the organization ranges from Very Poor Experience, Poor Experience, Fair, Good Experience, to Very Good Experience. Where \"Very Poor Experience\" means the onboarding needs to be fixed and improved immediately, while \"Very Good Experience\" means the onboarding was effective and successful.",
    "translations": [
      {
        "language": "AR",
        "text": "تتدرج عملية الإعداد والتهيئة الشاملة للشركة وفقاً لمعايير مقياس النتائج التي تبدأ من تجربة سيئة للغاية، تجربة سيئة، تجربة معتدلة، تجربة جيدة، إلى تجربة جيدة للغاية، حيث أن عبارة 'تجربة سيئة للغاية' تعني أنه يتعين إعادة النظر في عملية الإعداد والتهيئة وتحسينها على الفور، بينما عبارة 'تجربة جيدة للغاية' تعني أن عملية الإعداد والتهيئة كانت فعالة وناجحة."
      }
    ]
  },
  {
    "key": "txtCalculationProcess2",
    "text": "The overall score for each factor gives the new employees' perception of that factor; the score is an average rating based on the received feedback.",
    "translations": [
      {
        "language": "AR",
        "text": "توضح الدرجة الإجمالية لكل عامل من تلك العوامل مدى إدراك الموظفين الجدد لذلك العامل. تحسب النتيجة التي يتم الحصول عليها على أساس متوسط التقييم بناءً على الردود المستلمة."
      }
    ]
  },
  {
    "key": "txtCalculationProcess3",
    "text": "The overall score for each phase tells how successful the individual and stakeholders contributed to the onboarding experience.",
    "translations": [
      {
        "language": "AR",
        "text": "توضح النتيجة الإجمالية لكل مرحلة من المراحل مدى نجاح مساهمة الموظف وأصحاب الشركة في عملية الإعداد والتهيئة."
      }
    ]
  },
  {
    "key": "txtResultsRating",
    "text": "Results Rating",
    "translations": [
      {
        "language": "AR",
        "text": "مقياس النتائج"
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations",
    "translations": [
      {
        "language": "AR",
        "text": "توصيات"
      }
    ]
  },
  {
    "key": "txtRecommendations",
    "text": "Recommendations:",
    "translations": [
      {
        "language": "AR",
        "text": "توصيات"
      }
    ]
  },
  {
    "key": "belongingRecommendations",
    "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>Send new employee announcements to the team in the workplace. The welcoming email alerts current employees to join in welcoming new employees into the workplace, giving a positive impression and paving the way for employee engagement and success</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>Assign new employees with a buddy and encourage mentorships. Peers and mentors can help improve the onboarding experience by reassuring and providing social support for new employees. Encourage new employees to find mentors and a community through networking opportunities for informal conversations. Additionally, give them opportunities to share their identity, stories, and perspective without fear of being judged through community-based activities or networking events</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>Involve senior leadership in meeting discussions or group coffee chats. This helps new employees feel more visible and transparent to the highest levels. This also sends a clear message that top management is interested in all employees. Organizing periodic team lunches and offsites in the workplace can also enhance team bonding between new and existing employees.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">4</span><p>Provide open channels of communication between new employees and superiors. Social support has an effective impact on reducing the stress of new employees to help in smoothing the transition into a new workplace.</p></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>إرسال إعلانات عن الموظف الجديد لموظفي الشركة في مكان العمل. حيث أن إرسال بريد الكتروني ترحيبي من شأنه أن يحفز الموظفين الحاليين للمشاركة في الترحيب بالموظفين الجدد في مكان العمل، مما يترتب عليه منح انطباعاً إيجابياً لدى الموظفين الجدد ويمهد الطريق أمامهم للاندماج في العمل والنجاح فيه.</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>تعيين الموظفين الجدد مع فريق عمل إرشادي قادر على كسب صداقتهم وتشجيعهم. حيث أنه يمكن لزملاء العمل والمشرفين تقديم المساعدة في تعزيز عملية الإعداد والتهيئة للموظفين الجدد من خلال طمأنتهم وتقديم الدعم الاجتماعي لهم، و تشجيعهم على التواصل مع جميع زملائهم بطريقة ودية خارج نطاق مواضيع العمل، بالإضافة إلى منحهم فرصةً للتعريف عن هويتهم ومشاركة قصصهم ووجهات نظرهم مع باقي الموظفين دون الخوف من آرائهم أو أن يتم الحكم عليهم، وذلك من خلال إقامة فعاليات مجتمعية أو أنشطة  تعزز تواصلهم الاجتماعي.</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>إشراك الإدارة العليا في المناقشات التي تتم في الاجتماعات المعقودة بين الموظفين أو تلك التي تتم من خلال المحادثات الجماعية الغير رسمية والخارجة عن نطاق العمل. حيث يساهم ذلك في منح الموظفين الجدد الإحساس بحضورهم واندماجهم في مكان العمل، كما أن ذلك من شأنه أن يبعث رسالة واضحة مفادها أن الإدارة العليا مهتمة بجميع الموظفين دون تفرقة، علاوة على ذلك، فإن تنظيم وجبات غداء دورية للموظفين خارج مكان العمل وداخله من شأنها أن تؤدي أيضاَ إلى تعزيز الروابط فيما بين الموظفين الجدد والموظفين الحاليين.</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">4</span><p>توفير قنوات للتواصل الاجتماعي بين الموظفين الجدد ومدرائهم.وهذا يوفر لهم دعم اجتماعي فعال والذي بدوره يؤثر بشكل ملحوظ في الحد من الضغوط التي قد يشعر بها الموظفين الجدد وذلك لغرض المساعدة في تسهيل انتقالهم إلى مكان العمل الجديد.</p></div>"
      }
    ]
  },
  {
    "key": "roleClarityRecommendations",
    "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>Have a clear job description covering the roles and responsibilities. This will help new employees fully understand their job commitments and tasks. Conduct regular role audits with teams and managers to keep up with changes in the job role. This ensures that the new employee and teams have a realistic understanding of the job during the recruiting and onboarding processes.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>Integrate new employees into the flow of work in the organization. Ensure superiors and team members are involved and can brief new employees about their role, how it impacts organizational success, and their expectations from them. Involve new managers in the new initiatives in the workplace, such as setting strategic directions & plans, improvements, assessing issues, and initiating solutions to make them feel engaged and valued.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>Implement a new-employee orientation program and an effective welcome plan. Prepare a checklist to create structure and ensure all the necessary steps are done. The checklist includes -confirming the arrival of the new employee, introducing them to current employees, giving them an office tour, completing their paperwork, handing over the employee’s handbook & the organization's policies, having their work area set up, etc.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">4</span><p>Ensure the workplace goals and objectives are practical and clear. Orient the new employees about the organization's mission and vision to make sure that employees understand what needs to be accomplished to achieve the workplace's goals and objectives</p></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>الحصول على وصف وظيفي واضح يغطي ويوضح جميع الأدوار والمسؤوليات الوظيفية. ويساعد الوصف الوظيفي الموظفين الجدد على فهم التزاماتهم ومهامهم الوظيفية بشكل كامل. هذا وبالإضافة إلى القيام بإجراء عمليات تدقيق دورية منتظمة مع الموظفين والإداريين لمواكبة التغييرات في الدور الوظيفي، حيث أن ذلك من شأنه ضمان أن يكون لدى الموظف الجديد وباقي الموظفين فهم واضح للدور الوظيفي أثناء عمليات التوظيف والتجهيز لعملية الإعداد والتهيئة.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>دمج الموظفين الجدد في مهام وأعمال الشركة وذلك بالتأكد من مشاركة المدراء وفريق العمل بمهمة تعريف الموظفين الجدد بأدوارهم الوظيفية وتوضيح مدى تأثير ذلك على نجاح الشركة، وتوضيح ما هو متوقع القيام به من قبلهم. هذا وبالإضافة إلى القيام بإشراك المدراء الجدد في المبادرات الجديدة في مكان العمل المتمثلة في وضع التوجهات والخطط الإستراتيجية، والتخطيط لتطوير العمل، وتقييمه، وإيجاد الحلول للمشكلات الممكنة، إلخ. مما يعزز اندماجهم الوظيفي وشعورهم بالتقدير.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>تطبيق برنامج توجيه الموظف الجديد ووضع خطة ترحيب فعالة عن طريق القيام بإعداد قائمة توضح هيكلية ذلك البرنامج والتأكد من تنفيذ جميع الخطوات اللازمة بهذا الخصوص. وتتضمن القائمة ما يلي: تأكيد تاريخ وصول الموظف الجديد، وتعريفه بالموظفين الحاليين، والقيام بجولة تعريفية معه في الشركة، واستكمال أوراقه الخاصة بالعمل، وتسليمه كتيب دليل الموظف وسياسات الشركة، وتجهيز منطقة العمل الخاصة به، وما إلى ذلك.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">4</span><p>التأكد من أن أهداف وغايات الشركة فعالة وواضحة عن طريق تعريف الموظفين الجدد برؤية ورسالة الشركة وذلك لغرض التأكد من أن الموظفين يدركون ما يجب إنجازه لتحقيق أهداف وغايات الشركة.</p></div>"
      }
    ]
  },
  {
    "key": "adaptabilityRecommendations",
    "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>Plan a new employee welcome strategy. Prepare administrative staff and HR for the new employee's day one well in advance. Invite new employees for an office breakfast/lunch or a coffee chat with current employees to make them feel welcomed and involved in the company's culture.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>Ensure the new employee's workstation is completely set up and organized. This means the new employees' work location is available, clean, organized, and set up, and they have a welcome kit consisting of everything they need to feel settled and equipped, like an ID card, logins & passwords, coffee mug, computer, phone, office supplies, and a handwritten welcome note from the top management. Ensure they can access online tools, computer networks, and others. </p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>Implement a complete office tour. Give new employees an efficient tour around the office (restrooms, break/lunchrooms, explain any department procedures, coffee/tea location, printers, etc.) and introduce them to co-workers and team members to make them feel welcome.</p></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>وضع خطة استراتيجيه للترحيب بالموظف الجديد وذلك من خلال قيام الإداريين وموظفي الموارد البشرية باستقبال الموظف الجديد والترحيب به منذ اليوم الأول من تاريخ التحاقه بالشركة، بالإضافة إلى القيام بدعوة الموظف الجديد لتناول وجبة إفطار/ غداء في الشركة أو الإعداد لجلسة احتساء قهوة مع الموظفين الحاليين لجعله يشعر بالترحيب وضمان إشراكه في التقاليد المتبعة في الشركة.</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>التأكد بشكل كامل من جاهزية مكان العمل الذي سيباشر به الموظف الجديد عمله، وهذا يعني بطبيعة الحال أن يكون مكان عمل الموظف الجديد متوفراً ونظيفاً ومنظماً ومجهزاً، وأن يتم تزويده بالباقة الترحيبية المتكونة من جميع ما يحتاج إليه الموظف الجديد لمنحه الشعور بالاستقرار والجاهزية للعمل على سبيل المثال: بطاقة الهوية، وكلمات المرور وكلمات السر، وكوب القهوة، والحاسوب، والهاتف، والتجهيزات المكتبية، وكذلك مذكرة ترحيب مكتوبة بخط اليد من الإدارة العليا. هذا وبالإضافة إلى، التأكد من إمكانية وصوله إلى الأدوات المستخدمة عبر الإنترنت وشبكات الحاسوب وما إلى ذلك.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>القيام بجولة مكتبية كاملة عن طريق السماح للموظفين الجدد القيام بجولة كاملة حول أقسام الشركة (دورات المياه، غرف الإفطار/ الغداء، مع تقديم  الشرح لهم بخصوص أي إجراءات خاصة بالقسم، مكان تجهيز القهوة/ الشاي، مكان وجود الطابعات، وما إلى ذلك)، وكذلك تقديمهم وتعريفهم بزملاء العمل وأفراد الشركة لمنحهم الشعور بالترحيب.</p></div>"
      }
    ]
  },
  {
    "key": "continuityRecommendations",
    "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>Improve work-life balance. Provide flexibility if the desired outcomes are achieved. Ensure the workload is manageable, mapped to new employees' strengths, and can expand their current capabilities to prevent boredom or burnout. Encourage teamwork and collaboration whenever needed to ensure the team outcomes are fulfilled. Allowing time off and options to work from home when needed can help. Finally, try not to overwhelm them with excessive job demands, unnecessary work pressure, and long working hours. </p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>Develop and provide a clear career pathway for timely growth and advancement. Grant new employees a structured document that maps out roles, responsibilities, and considerations for progression in their new careers. Support training and development of new employees to advance in the career path of their choice and grow within the firm.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>Provide meaningful work that can challenge them. Assign challenging and exciting tasks to new employees that contribute to the success of the workplace and express gratitude and appreciation once tasks are done. Treat them well and reward them for their contribution whenever possible. </p></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>تعزيز مفهوم التوازن بين الحياة العملية والاجتماعية من خلال توفير بيئة عمل مرنة تهتم بالإنتاجية وتحقيق النتائج المرجوة بدلاً من الاهتمام بساعات العمل، وكذلك التأكد من أنه يمكن التحكم في أعباء العمل، وتوظيفها بحسب قدرة كل موظف في تحمل هذه الأعباء، واعتبارها نقاط قوة تساهم في توسيع نطاق قدراتهم الحالية كما تحد من شعورهم بالملل أو عدم تكافؤ قدراتهم مع العمل الموكل لهم. هذا وبالإضافة إلى تعزيز مفهوم العمل الجماعي والتعاون كلما دعت الحاجة لذلك، لضمان تحقيق النتائج المرجوة من قبل فريق العمل، والسماح بأخذ الاستراحات والإجازات المستحقة للموظفين ومنحهم حرية القيام بأعمالهم من منازلهم إذا دعت الحاجة لذلك. وأخيرًا، عدم محاولة إرهاقهم بمطالب العمل المفرطة، وعدم ممارسة الضغط عليهم بالأعمال غير الضرورية ، وتجنيبهم العمل لساعات طويلة.</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>تطوير وتوفير مسار وظيفي واضح يتلاءم مع نمو العمل وتقدمه وذلك من خلال تزويد الموظفين الجدد بالمستند الذي يوضح هيكلية العمل ويحدد الأدوار والمسؤوليات والأمور التي يتوجب أخذها بعين الاعتبار من أجل النهوض قدماً في وظائفهم الجديدة. هذا وبالإضافة إلى دعم تدريب وتطوير الموظفين الجدد للنهوض قدماً في المسار الوظيفي الذي يختارونه والنمو والتقدم من خلال الشركة.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>توكيل أعمال هامة للموظفين الجدد لتشكل تحدي لهم وذلك من خلال تحديد مهام وأنشطة مميزة وذات تحديات للموظفين الجدد التي من شأنها أن تساهم في نجاح الشركة، وقيام الشركة بالتعبير عن مدى امتنانها وتقديرها للموظفين بمجرد انتهائهم من أداء هذه المهام. تجدر الإشارة إلى أن الشركة مسؤولة عن معاملة الموظفين الجدد بطريقة حسنة ومكافأتهم على مساهماتهم البناءة كلما أمكن ذلك.</p></div>"
      }
    ]
  },
  {
    "key": "efficacyRecommendations",
    "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>Employ and develop candidates with high self-efficacy. Hiring for resilience and self-efficacy can improve the overall self–efficacy of the team and organization (using suitable psychometric assessments). Screening for high self-efficacy is recommended for high-stress roles and roles where employees are expected to operate in a fast-paced environment since these new employees are more likely to be motivated to perform well. Guided experiences, mentors, and role modeling of desired behaviors can help new employees improve their self-efficacy.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>Set reasonable goals and expectations. The complexity of job demands has an impact on self-efficacy. Assign tasks based on the new employees' strengths and slowly move them to more challenging roles. It is important to adequately challenge new employees to prevent boredom and disengagement as they decrease self-efficacy or create a false sense of self-efficacy.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>Break larger goals into specific and measurable bits. Allow new employees to build their confidence through quick and small wins and gradually gain proficiency over complex, challenging tasks without much pressure of time or outcomes, if possible. These accomplishments can increase their sense of task proficiency and confidence.</p></div>",
    "translations": [
      {
        "language": "AR",
        "text": "<div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">1</span><p>توظيف مرشحين ذوي كفاءة ذاتية عالية حيث يمكن أن يؤدي ذلك إلى تعزيز الكفاءة الذاتية الشاملة لفريق العمل والشركة، وكنتيجة لذلك يوصى بإجراء اختبار لفحص الكفاءة الذاتية العالية للموظفين الجدد ممن يناط بهم القيام بأدوار وظيفية عالية الضغط (باستخدام اختبارات التقييم النفسي المناسبة) حيث يتوقع من هؤلاء الموظفين العمل في بيئة تتطلب العمل بخطى سريعة، حيث أنه من المرجح أن يكون هؤلاء الموظفون الجدد ذوو الكفاءة الذاتية العالية أكثر تحفيزاً وقدرة على الأداء الجيد. تجدر الإشارة إلى أن ذوي الخبرات عالية المستوى وكذلك المشرفين والنماذج من الموظفين الذين يحتذى بهم من ذوي السلوكيات رفيعة المستوى يمكنهم مساعدة الموظفين الجدد على تحسين وتعزيز كفاءاتهم الذاتية.</p></div> <div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">2</span><p>وضع أهدافاً وتوقعات معقولة حيث أن تعقيد متطلبات العمل له تأثير كبير على الكفاءة الذاتية، لذلك يتعين تحديد مهام وظيفية تستند إلى نقاط قوة الموظفين الجدد ونقلهم تدريجياً إلى مهام وظيفية ذات مسؤوليات أشمل. ومن المهم توخي الحذر عند إسناد مهام وظيفية ذات مستوى عال للموظفين الجدد لتجنب تذمرهم وشعورهم بالملل وعدم اندماجهم بالعمل، حيث أن ذلك من شأنه أن يخفض من مستوى الكفاءة الذاتية لديهم أو أن ينشئ لديهم شعوراً خاطئاً حيال كفاءتهم الذاتية.</p></div><div class=\"flex flex-row items-start gap-2\"><span style=\"min-width:1.25rem\" class=\" text-white bg-exp leading-5 text-center rounded-full w-5 h-5 font-semibold text-xs\">3</span><p>تقسيم الأهداف الكبرى إلى أجزاء محددة وقابلة للتقييم وذلك عن طريق السماح للموظفين الجدد ببناء ثقتهم من خلال المكاسب السريعة والصغيرة، واكتساب الكفاءة تدريجياً من خلال القيام بمهام أكثر صعوبة وتحدياً دون إحداث المزيد من الضغوط من حيث الوقت أو النتائج، إن أمكن، حيث يمكن لتلك الإنجازات أن تعزز شعورهم بالكفاءة والمهنية وتنمي ثقتهم بأنفسهم.</p></div>"
      }
    ]
  },
  {
    "key": "AP_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost employee onboarding factors.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى إعداد وتهيئة الموظفين."
      }
    ]
  },
  {
    "key": "AP_T_2_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_T_2_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_T_3_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_T_3_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_T_4_TITLE",
    "text": "Crate Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_4_DESCRIPTION",
    "text": "After selecting an entity or company-wide for your action plan, click Create Action Plan to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار الجهة محددة أو على مستوى الشركة لخطة العمل، اضغط على إنشاء خطة عمل للبدء."
      }
    ]
  },
  {
    "key": "AP_T_5_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_T_5_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_T_6_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_T_6_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_T_7_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_T_7_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_T_8_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_T_8_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_T_9_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_T_9_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan and then click on continue.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك، ثم اضغط على متابعة."
      }
    ]
  },
  {
    "key": "AP_T_10_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_T_10_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_T_11_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_T_11_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_T_12_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_T_12_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_T_13_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_13_DESCRIPTION",
    "text": "Select key factors or topics based on low scores and employee feedback to drive targeted improvements.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر العوامل أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة."
      }
    ]
  },
  {
    "key": "AP_T_14_TITLE",
    "text": "Status Bar",
    "translations": [
      {
        "language": "AR",
        "text": "شريط الحالة"
      }
    ]
  },
  {
    "key": "AP_T_14_DESCRIPTION",
    "text": "View all selected focus areas, initiatives, and tasks in one place.",
    "translations": [
      {
        "language": "AR",
        "text": "هنا يتم عرض جميع مجالات التركيز والمبادرات والمهام المحددة في مكان واحد."
      }
    ]
  },
  {
    "key": "AP_T_15_TITLE",
    "text": "Factor Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب العامل"
      }
    ]
  },
  {
    "key": "AP_T_15_DESCRIPTION",
    "text": "Based on the selected onboarding factors, choose the ones you want to focus on.\nNote: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "استنادًا إلى عوامل إعداد وتهيئة الموظفين، اختر العوامل التي ترغب في التركيز عليها.\nتلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_T_16_TITLE",
    "text": "Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_T_16_DESCRIPTION",
    "text": "Once you’ve selected your focus area, choose the desired predefined initiative by checking the box next to it.\nNote: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد اختيار مجال التركيز، حدد المبادرة المعرفة مسبقًا عن طريق تحديد المربع بجانبها.\nتلميح: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_T_17_TITLE",
    "text": "Manual Initiative Entry",
    "translations": [
      {
        "language": "AR",
        "text": "إدخال المبادرة يدويًا"
      }
    ]
  },
  {
    "key": "AP_T_17_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_T_18_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_T_18_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_T_19_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_T_19_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_T_20_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_20_DESCRIPTION",
    "text": "Set the due date for your initiative.\nNote: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة.\nتلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_T_21_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_T_21_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability.\nNote: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة.\nتلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_T_22_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_T_22_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “🌐”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_T_23_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_T_23_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_T_24_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_T_24_DESCRIPTION",
    "text": "You can update your initiative details by clicking on the three vertical dots.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تعديل تفاصيل المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_T_25_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_T_25_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_T_26_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_T_26_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_T_27_TITLE",
    "text": "AI-Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_T_27_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_T_28_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_T_28_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "AP_T_29_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_T_29_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض f مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_T_30_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_T_30_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Factors.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو عوامل."
      }
    ]
  },
  {
    "key": "AP_T_31_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_T_31_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox, or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_T_32_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_T_32_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_T_33_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_T_33_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_T_34_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_T_34_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_T_35_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_T_35_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders.\nNote: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية.\nتلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_T_36_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_T_36_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_T_37_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_T_37_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_T_38_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_T_38_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted.\nNote: A minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات.\nتلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_T_39_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_T_39_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_T_40_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_T_40_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  },
  {
    "key": "AP_S_T_1_TITLE",
    "text": "Action Planning",
    "translations": [
      {
        "language": "AR",
        "text": "خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_1_DESCRIPTION",
    "text": "In the “Action Planning” page, you turn employee feedback into clear initiatives. Here, you create, set up, and launch your plan to boost the onboarding process.",
    "translations": [
      {
        "language": "AR",
        "text": "في صفحة خطة العمل، يتم تحويل ملاحظات الموظفين إلى مبادرات واضحة وقابلة للتنفيذ. هنا يمكنك إنشاء خطتك، إعدادها، وإطلاقها لتعزيز مستوى إعداد وتهيئة الموظفين."
      }
    ]
  },
  {
    "key": "AP_S_T_2_TITLE",
    "text": "Create Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "إنشاء خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_2_DESCRIPTION",
    "text": "After selecting an entity or choosing company-wide, click New Action Plan in the center to get started, or use the top-right button.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد تحديد وحدة معيّنة أو اختيار مستوى الشركة بالكامل، انقر على خطة عمل جديدة في وسط الشاشة للبدء، أو استخدم الزر الموجود في أعلى اليسار."
      }
    ]
  },
  {
    "key": "AP_S_T_3_TITLE",
    "text": "Filters",
    "translations": [
      {
        "language": "AR",
        "text": "الفلاتر"
      }
    ]
  },
  {
    "key": "AP_S_T_3_DESCRIPTION",
    "text": "Click here to filter and create an action plan for a selected entity or company-wide.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط هنا لاستخدام الفلاتر وإنشاء خطة عمل لجهة محددة أو على مستوى الشركة بالكامل."
      }
    ]
  },
  {
    "key": "AP_S_T_4_TITLE",
    "text": "Entity Selection – by Business Level",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار الوحدة - جهة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_4_DESCRIPTION",
    "text": "Select the desired entity for your action plan by checking its box, then click Apply.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر الوحدة المطلوبة لخطة العمل الخاصة بك عن طريق تحديد المربع بجانبها، ثم اضغط على تطبيق."
      }
    ]
  },
  {
    "key": "AP_S_T_5_TITLE",
    "text": "Action Plan List",
    "translations": [
      {
        "language": "AR",
        "text": "قائمة خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_5_DESCRIPTION",
    "text": "The action plan list displays all created action plans, showing their scope along with the number of focus areas, initiatives, and tasks.",
    "translations": [
      {
        "language": "AR",
        "text": "تعرض قائمة خطط العمل جميع الخطط التي تم إنشاؤها، موضحة نطاق كل منها وعدد مجالات التركيز والمبادرات والمهام."
      }
    ]
  },
  {
    "key": "AP_S_T_6_TITLE",
    "text": "Edit Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل خطط العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_6_DESCRIPTION",
    "text": "Edit or delete the action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعديل أو حذف خطط العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_7_TITLE",
    "text": "Accessing Action Plan",
    "translations": [
      {
        "language": "AR",
        "text": "الوصول إلى خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_7_DESCRIPTION",
    "text": "To access an action plan, click Open.",
    "translations": [
      {
        "language": "AR",
        "text": "للوصول إلى خطة العمل، اضغط على فتح."
      }
    ]
  },
  {
    "key": "AP_S_T_8_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_8_DESCRIPTION",
    "text": "Give your plan a clear, descriptive name to get started.",
    "translations": [
      {
        "language": "AR",
        "text": "امنح خطتك عنوانًا واضحًا للبدء."
      }
    ]
  },
  {
    "key": "AP_S_T_9_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_9_DESCRIPTION",
    "text": "Add a brief description to explain the purpose and focus of your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "أضف وصفًا موجزًا لشرح هدف وتركيز لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_10_TITLE",
    "text": "Translation",
    "translations": [
      {
        "language": "AR",
        "text": "الترجمة"
      }
    ]
  },
  {
    "key": "AP_S_T_10_DESCRIPTION",
    "text": "Translate text manually with a click on “” or “✨” and let our magical AI Tool do the job for you!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بترجمة النص يدوياً بنقرة واحدة على “”أو انقر على “✨” واسمح لأداة الذكاء الاصطناعي بالقيام بالمهمة بالنيابية عنك!"
      }
    ]
  },
  {
    "key": "AP_S_T_11_TITLE",
    "text": "Scope",
    "translations": [
      {
        "language": "AR",
        "text": "النطاق"
      }
    ]
  },
  {
    "key": "AP_S_T_11_DESCRIPTION",
    "text": "The “Scope” shows whether the action plan is applied organization-wide or to a specific business level.",
    "translations": [
      {
        "language": "AR",
        "text": "يعرض \"النطاق\" ما إذا كانت خطة العمل تنطبق على المنظمة بأكملها أو على مستوى عمل محدد."
      }
    ]
  },
  {
    "key": "AP_S_T_12_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة"
      }
    ]
  },
  {
    "key": "AP_S_T_12_DESCRIPTION",
    "text": "Choose the start and end dates for your action plan.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر تاريخ البدء وتاريخ الانتهاء لخطة العمل الخاصة بك."
      }
    ]
  },
  {
    "key": "AP_S_T_13_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_13_DESCRIPTION",
    "text": "Once everything looks good, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد التأكد من أن كل شيء يبدو على ما يرام، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_14_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_14_DESCRIPTION",
    "text": "Select key onboarding factors or topics based on low scores and employee feedback to drive targeted improvements. Note: An upward arrow (↑) signifies high organizational impact, while a downward arrow (↓) indicates low impact.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر العوامل إعداد وتهيئة الموظفين أو المواضيع الرئيسية بناءً على النتائج المنخفضة وملاحظات الموظفين لدعم تحسينات موجهة وفعّالة. تلميح: يشير السهم للأعلى (↑) إلى تأثير مرتفع على المنظمة، بينما يشير السهم للأسفل (↓) إلى تأثير منخفض."
      }
    ]
  },
  {
    "key": "AP_S_T_15_TITLE",
    "text": "Topic Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز حسب الموضوع"
      }
    ]
  },
  {
    "key": "AP_S_T_15_DESCRIPTION",
    "text": "Topic-based Focus Areas, generated from employee comments, these topics highlight key concerns and show the number and distribution of positive, neutral, and negative comments.",
    "translations": [
      {
        "language": "AR",
        "text": "في مجالات التركيز حسب الموضوع، يتم إنشاء المواضيع من تعليقات الموظفين، حيث تسلط الضوء على أبرز الاهتمامات وتعرض عدد وتوزيع التعليقات الإيجابية والمحايدة والسلبية."
      }
    ]
  },
  {
    "key": "AP_S_T_16_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_16_DESCRIPTION",
    "text": "Once you’re satisfied with the selected focus areas, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد التأكد من مجالات التركيز المختارة، اضغط على “التالي” للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_17_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_17_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your initiatives!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المبادرات المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_18_TITLE",
    "text": "Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات"
      }
    ]
  },
  {
    "key": "AP_S_T_18_DESCRIPTION",
    "text": "Select your focus area and choose the desired initiative by checking the box next to it. Note: predefined initiatives cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "اختر مجال التركيز، ثم حدّد المبادرة المربع بجانبها. ملاحظة: لا يمكن تعديل المبادرات المعرفة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_19_TITLE",
    "text": "Custom Initiative",
    "translations": [
      {
        "language": "AR",
        "text": "مبادرة مخصصة"
      }
    ]
  },
  {
    "key": "AP_S_T_19_DESCRIPTION",
    "text": "You can also add initiatives manually.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك أيضًا إضافة المبادرات يدويًا."
      }
    ]
  },
  {
    "key": "AP_S_T_20_TITLE",
    "text": "Title",
    "translations": [
      {
        "language": "AR",
        "text": "العنوان"
      }
    ]
  },
  {
    "key": "AP_S_T_20_DESCRIPTION",
    "text": "Fill in your \"Initiative Title\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة عنوان المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_21_TITLE",
    "text": "Description",
    "translations": [
      {
        "language": "AR",
        "text": "الوصف"
      }
    ]
  },
  {
    "key": "AP_S_T_21_DESCRIPTION",
    "text": "Fill in your \" Initiative Description\"",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعبئة وصف المبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_22_TITLE",
    "text": "Duration",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_22_DESCRIPTION",
    "text": "Set the due date for your initiative. Note: The due date cannot be later than the overall action plan due date.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد تاريخ الإكمال المبادرة. تلميح: لا يمكن أن يكون تاريخ الإكمال للمبادرة بعد تاريخ إكمال خطة العمل الإجمالي."
      }
    ]
  },
  {
    "key": "AP_S_T_23_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_23_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability. Note: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة. تلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_24_TITLE",
    "text": "AI-Generated Initiatives",
    "translations": [
      {
        "language": "AR",
        "text": "المبادرات المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_24_DESCRIPTION",
    "text": "Generate initiatives effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your action plan!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المبادرات بسهولة بالضغط على“✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة لخطة العمل!"
      }
    ]
  },
  {
    "key": "AP_S_T_25_TITLE",
    "text": "Edit",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل"
      }
    ]
  },
  {
    "key": "AP_S_T_25_DESCRIPTION",
    "text": "You can update your initiative details, such as the owner and the due date, by clicking on the three vertical dots. Note: You can edit the title and the description of the custom initiative as well.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث تفاصيل المبادرة، مثل المسؤول وتاريخ الاستحقاق، من خلال النقر على النقاط الرأسية الثلاث. ملاحظة: يمكنك أيضًا تعديل عنوان المبادرة المخصصة ووصفها."
      }
    ]
  },
  {
    "key": "AP_S_T_26_TITLE",
    "text": "Delete",
    "translations": [
      {
        "language": "AR",
        "text": "مسح"
      }
    ]
  },
  {
    "key": "AP_S_T_26_DESCRIPTION",
    "text": "You can delete any initiative by clicking on the three vertical dots",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح المبادرة بالضغط على النقاط الرأسية الثلاث."
      }
    ]
  },
  {
    "key": "AP_S_T_27_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_27_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, click “Next” to continue.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرات، اضغط على \"التالي\" للمتابعة."
      }
    ]
  },
  {
    "key": "AP_S_T_28_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_28_DESCRIPTION",
    "text": "Easily navigate between selected focus areas to select your tasks!",
    "translations": [
      {
        "language": "AR",
        "text": "تنقّل بسهولة بين مجالات التركيز المحددة لاختيار المهام المناسبة!"
      }
    ]
  },
  {
    "key": "AP_S_T_29_TITLE",
    "text": "Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_29_DESCRIPTION",
    "text": "Once you’ve selected your initiatives, choose the desired tasks by checking the box next to it. Hint: Predefined tasks cannot be edited.",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المبادرة، حدِّد المهام بوضع علامة في المربع المجاور لها. تلميح: لا يمكن تعديل المهام المحددة مسبقًا."
      }
    ]
  },
  {
    "key": "AP_S_T_30_TITLE",
    "text": "Add Task",
    "translations": [
      {
        "language": "AR",
        "text": "إضافة المهام يدويًا"
      }
    ]
  },
  {
    "key": "AP_S_T_30_DESCRIPTION",
    "text": "Add customized tasks based on your specific needs.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء مهام مخصصة وفقًا لاحتياجاتك."
      }
    ]
  },
  {
    "key": "AP_S_T_31_TITLE",
    "text": "Edit Task",
    "translations": [
      {
        "language": "AR",
        "text": "تعديل المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_31_DESCRIPTION",
    "text": "You can update the task by clicking on the pen icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك تحديث المهمة بالنقر على أيقونة القلم."
      }
    ]
  },
  {
    "key": "AP_S_T_32_TITLE",
    "text": "Delete Task",
    "translations": [
      {
        "language": "AR",
        "text": "مسح المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_32_DESCRIPTION",
    "text": "You can delete any task by clicking on the delete icon.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك مسح أي مهمة بالنقر على أيقونة المسح."
      }
    ]
  },
  {
    "key": "AP_S_T_33_TITLE",
    "text": "AI- Generated Tasks",
    "translations": [
      {
        "language": "AR",
        "text": "المهام المولَّدة بواسطة الذكاء الاصطناعي"
      }
    ]
  },
  {
    "key": "AP_S_T_33_DESCRIPTION",
    "text": "Generate tasks effortlessly by clicking “✨” and let our AI suggest smart, ready-to-use ideas for your initiative!",
    "translations": [
      {
        "language": "AR",
        "text": "قم بإنشاء المهام بسهولة بالضغط على “✨” ودع الذكاء الاصطناعي يقترح أفكارًا جاهزة للمبادرة!"
      }
    ]
  },
  {
    "key": "AP_S_T_34_TITLE",
    "text": "Assign Owner",
    "translations": [
      {
        "language": "AR",
        "text": "تعين المسؤول"
      }
    ]
  },
  {
    "key": "AP_S_T_34_DESCRIPTION",
    "text": "Assign an owner to each initiative to ensure clear responsibility and accountability. Hint: you can only assign only one owner per initiative",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتعيين مسؤول لكل مبادرة لضمان وضوح المسؤولية والمحاسبة. تلميح: يمكنك تعيين مسؤول واحد فقط لكل مبادرة."
      }
    ]
  },
  {
    "key": "AP_S_T_35_TITLE",
    "text": "Next",
    "translations": [
      {
        "language": "AR",
        "text": "التالي"
      }
    ]
  },
  {
    "key": "AP_S_T_35_DESCRIPTION",
    "text": "Once you’ve selected your tasks, click Next to continue. Note: each initiative must have at least 1 task and 1 owner",
    "translations": [
      {
        "language": "AR",
        "text": "بعد اختيار المهام، اضغط على التالي للمتابعة. ملاحظة: يجب أن تحتوي كل مبادرة على مهمة واحدة على الأقل ومالك واحد"
      }
    ]
  },
  {
    "key": "AP_S_T_36_TITLE",
    "text": "Action Plan Details",
    "translations": [
      {
        "language": "AR",
        "text": "تفاصيل خطة العمل"
      }
    ]
  },
  {
    "key": "AP_S_T_36_DESCRIPTION",
    "text": "Review your full action plan, including focus areas, initiatives, tasks, owners, and timelines—all in one place before launching.",
    "translations": [
      {
        "language": "AR",
        "text": "راجع تفاصيل خطة العمل بما في ذلك مجالات التركيز والمبادرات والمهام والمسؤولين والجداول الزمنية."
      }
    ]
  },
  {
    "key": "AP_S_T_37_TITLE",
    "text": "Launch",
    "translations": [
      {
        "language": "AR",
        "text": "إطلاق"
      }
    ]
  },
  {
    "key": "AP_S_T_37_DESCRIPTION",
    "text": "Once everything is set, click Launch to make your action plan live.",
    "translations": [
      {
        "language": "AR",
        "text": "بمجرد الانتهاء من الإعدادات، اضغط على إطلاق لبدء خطة العمل."
      }
    ]
  },
  {
    "key": "AP_S_T_38_TITLE",
    "text": "Tracking",
    "translations": [
      {
        "language": "AR",
        "text": "التتبع"
      }
    ]
  },
  {
    "key": "AP_S_T_38_DESCRIPTION",
    "text": "View overall progress, task status, and key details such as Focus Areas, Initiatives, dates, and time remaining at a glance.",
    "translations": [
      {
        "language": "AR",
        "text": "اعرض التقدم العام، حالة المهام، والتفاصيل الأساسية مثل مجالات التركيز والمبادرات والتواريخ والوقت المتبقي بنظرة سريعة."
      }
    ]
  },
  {
    "key": "AP_S_T_39_TITLE",
    "text": "Focus Areas",
    "translations": [
      {
        "language": "AR",
        "text": "مجالات التركيز"
      }
    ]
  },
  {
    "key": "AP_S_T_39_DESCRIPTION",
    "text": "Here you view the selected Focus Areas, whether Topics or Onboarding Factors.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض مجالات التركيز المختارة، سواء كانت مواضيع أو عوامل إعداد وتهيئة الموظفين."
      }
    ]
  },
  {
    "key": "AP_S_T_40_TITLE",
    "text": "Tasks Management",
    "translations": [
      {
        "language": "AR",
        "text": "إدارة المهام"
      }
    ]
  },
  {
    "key": "AP_S_T_40_DESCRIPTION",
    "text": "Mark individual tasks as done using the checkbox or finish all at once with Mark All as Complete.",
    "translations": [
      {
        "language": "AR",
        "text": "حدد المهام الفردية كمكتملة باستخدام المربع، أو قم بإكمال جميع المهام بالضغط على تحديد الكل كمكتمل."
      }
    ]
  },
  {
    "key": "AP_S_T_41_TITLE",
    "text": "Status Filter",
    "translations": [
      {
        "language": "AR",
        "text": "فرز حسب الحالة"
      }
    ]
  },
  {
    "key": "AP_S_T_41_DESCRIPTION",
    "text": "You can filter initiatives by status: In Progress, Completed, or Expired.",
    "translations": [
      {
        "language": "AR",
        "text": "يمكنك فرز المبادرات حسب الحالة: قيد التنفيذ مكتملة، أو منتهية."
      }
    ]
  },
  {
    "key": "AP_S_T_42_TITLE",
    "text": "Request for Feedback",
    "translations": [
      {
        "language": "AR",
        "text": "طلب ملاحظات"
      }
    ]
  },
  {
    "key": "AP_S_T_42_DESCRIPTION",
    "text": "Click “Request Feedback” to invite employees to share their opinions and experiences regarding the implemented initiative, and measure its impact.",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على طلب ملاحظات لدعوة الموظفين لمشاركة آرائهم وتجاربهم حول المبادرة المنفذة وقياس أثرها."
      }
    ]
  },
  {
    "key": "AP_S_T_43_TITLE",
    "text": "Respondent Selection",
    "translations": [
      {
        "language": "AR",
        "text": "اختيار المستجيب"
      }
    ]
  },
  {
    "key": "AP_S_T_43_DESCRIPTION",
    "text": "Invite respondents to share their feedback on the completed initiative to evaluate its effectiveness and overall impact.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بدعوة المستجيبين لتقديم ملاحظاتهم حول المبادرة المكتملة لمعرفة مدى فعاليتها."
      }
    ]
  },
  {
    "key": "AP_S_T_44_TITLE",
    "text": "Time Frame",
    "translations": [
      {
        "language": "AR",
        "text": "المدة الزمنية"
      }
    ]
  },
  {
    "key": "AP_S_T_44_DESCRIPTION",
    "text": "In Timeframe, you set the feedback deadline in addition to automated reminders. Hint: you can add up to three reminders",
    "translations": [
      {
        "language": "AR",
        "text": "في \"المدة الزمنية\"، يمكنك تحديد الإطار الزمني لتقديم ملاحظاتهم بالإضافة إلى تذكيرات تلقائية. تلميح: يمكنك إضافة ما يصل إلى ثلاثة رسائل تذكير."
      }
    ]
  },
  {
    "key": "AP_S_T_45_TITLE",
    "text": "Email Template",
    "translations": [
      {
        "language": "AR",
        "text": "نموذج البريد الإلكتروني"
      }
    ]
  },
  {
    "key": "AP_S_T_45_DESCRIPTION",
    "text": "Customize the email template sent or use the default template generated by Zenithr.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بتخصيص نموذج الإيميل أو استخدم النموذج الأساسي المُعرف من زينيثر."
      }
    ]
  },
  {
    "key": "AP_S_T_46_TITLE",
    "text": "Send Invite",
    "translations": [
      {
        "language": "AR",
        "text": "إرسال الدعوات"
      }
    ]
  },
  {
    "key": "AP_S_T_46_DESCRIPTION",
    "text": "Click Send Now to share the invitations with respondents.",
    "translations": [
      {
        "language": "AR",
        "text": "اضغط على إرسال الآن لمشاركة الدعوات مع المستجيبين."
      }
    ]
  },
  {
    "key": "AP_S_T_47_TITLE",
    "text": "Live Analytics",
    "translations": [
      {
        "language": "AR",
        "text": "التحليلات اللحظية"
      }
    ]
  },
  {
    "key": "AP_S_T_47_DESCRIPTION",
    "text": "Monitor real-time responses and track participation as feedback is submitted. Hint: Minimum of three responses is required to close the survey.",
    "translations": [
      {
        "language": "AR",
        "text": "تابع الردود بشكل فوري وراقب مستوى المشاركة لحظة بلحظة مع وصول الملاحظات. تلميح: يتطلب إغلاق الاستبيان ثلاثة ردود على الأقل."
      }
    ]
  },
  {
    "key": "AP_S_T_48_TITLE",
    "text": "Result View",
    "translations": [
      {
        "language": "AR",
        "text": "عرض النتائج"
      }
    ]
  },
  {
    "key": "AP_S_T_48_DESCRIPTION",
    "text": "Click View Results to see responses, overall rating, and response distribution to quickly evaluate the initiative’s impact and effectiveness",
    "translations": [
      {
        "language": "AR",
        "text": "انقر على عرض النتائج للاطلاع على الردود، التقييم العام، وتوزيع المشاركات لتقييم أثر المبادرة وفعاليتها بسرعة."
      }
    ]
  },
  {
    "key": "AP_S_T_49_TITLE",
    "text": "Export",
    "translations": [
      {
        "language": "AR",
        "text": "تحميل"
      }
    ]
  },
  {
    "key": "AP_S_T_49_DESCRIPTION",
    "text": "Easily showcase your progress! Click “Export” to save and share your initiatives, tasks, feedback, and live dashboard data as a PDF.",
    "translations": [
      {
        "language": "AR",
        "text": "قم بعرض تقدم خطة العمل بكل سهولة! انقر على \"تحميل\" لحفظ ومشاركة المبادرات والمهام وملاحظات الموظفين وبيانات لوحة التحكم المباشرة بصيغة PDF."
      }
    ]
  }
]